/**
 * StandOverviewDetailPage.jsx — Stand Detayı (Proje Stand Listesi)
 * Route: /Management/Projects/Stands/:standId
 *
 * Fuar fotoğrafı banner + kroki (grid üzerinde stand şekli) görselleştirmesi
 * ile "Proje Bilgiler" sekmesi tam işlevli. "Proje Evrakları" sekmesinde her
 * dosyaya tıklayınca açılan popover'dan inceleyen kişi dosyayı Uygun/Red
 * işaretleyebilir ve bağımsız olarak bir Proje Taahütnamesi için "ana belge"
 * seçebilir (chooseFileForCommitment) — seçilen dosya "Proje Durumu"
 * sekmesinde (eski adıyla "Proje Taahütnameleri", boş duran eski "Proje Durumu"
 * sekmesiyle birleştirildi) ilgili taahhütnamenin altında görünür.
 *
 * 2026-08-25: "Kroki" sekmesindeki "yakında" placeholder'ı kalktı — yerine ayrı bir
 * uygulamadan (fdsvector) gömülen salon STAND PLANI geldi, bkz.
 * Components/Kroki/KrokiVectorEmbed.jsx. Gömme ucu tek standı izole etmez, salonun
 * tamamını çizer; stand bağı şekil düzeyindedir (şeklin data'sında standId/standNo).
 * Sekme bilinçli olarak hasProject kapısının dışında — salon yerleşimi proje
 * kaydından bağımsızdır.
 *
 * Alan eşlemesi: başlıktaki büyük isim = firmaName (katılımcı firma, "kimin
 * standı" anlamında), alt satır = dekoratorFirmaName. Bilgi kartındaki
 * "Stant Adı" da aynı firmaName'i, "Stand Numarası" ise standName'i gösterir
 * — bu sayfanın referans aldığı ekranda ikisi ayrı alanlar, elimizdeki veri
 * modelinde en yakın eşleşme bu.
 *
 * standArea/floorInfo: backend'de henüz yok, standOverviewService.js'te mock
 * olarak eklendi (KURAL: standOverviewService.js'teki not).
 *
 * 2026-07-18: inceleyen kişi tarafının revizyon konuşması akışı buraya taşındı
 * (önceden yanlışlıkla ProjectDetailPage.jsx'teydi — Projeler Listesi/Proje Detayı
 * başka bir geliştiricinin sayfaları, dokunulmuyor). projectService.js'teki gerçek
 * kayda standId üzerinden köprüyle ulaşılır (bkz. getProjectByStandId — aynı köprü
 * FirmaStandDetailPage.jsx'in salt-okunur tarafında da kullanılıyor); iki servis
 * dosyası ayrı mock veri setleri kullandığı için standId tek ortak alan, çoğu stand
 * için bridgedProject null kalır. Yeni/yanıt/çöz/sil mutasyonları projectService.js'in
 * beklediği proje id'siyle (bridgedProject.id) çağrılır, standId'yle DEĞİL. Tekil
 * konuşma sayfası: StandRevisionDetailPage.jsx (`/Management/Projects/Stands/:standId/revisions/:revisionId`).
 *
 * 2026-09-04: bu sayfa Stand Listesi'nden geri kalmıştı. Backend 2026-08-29'da bilgi
 * pillerini gönderdiğinde (missing-pills-guide.md) sadece StandListPage güncellendi ve
 * iki sayfa aynı stand için FARKLI ŞEYLER söylemeye başladı:
 *   · İnşa İzni burada `requiredCount === approvedCount` boolean'ından türetiliyordu →
 *     "İnşaat İzni Yok" yazıyordu, liste aynı standa "İzin Bekliyor" derken. Artık
 *     ikisi de `constructionPermit` durum aramasını (renk dahil DB'den) okuyor.
 *   · İş İzni bu sayfada HİÇ yoktu — eklendi (workPermit rollup'ı, §6).
 *   · Taahhütnameler standFileId 5'in alt dosyalarından SENTEZLENİYORDU → canlıda
 *     "Belge Yok" diyordu; kaynak belgeler 2026-08-29'dan beri 2/7'de. Artık roster'ın
 *     gerçek üretim zinciri (`commitments[].state`) kullanılıyor, sentez fallback.
 *   · Kategori/kat/tip/yapı/alan/yükseklik/kW pilleri ve Yerli-Yabancı eklendi.
 *   · Katalogdan gelen stand tipi adlarındaki " (n)" paralel-ağaç işareti atılıyor
 *     (roster adları zaten temiz geliyordu, iki sayfa farklı ad basıyordu).
 * Ortak sözlük artık Components/Projects/StandPills.jsx'te — iki sayfa da oradan
 * okuyor, tekrar kaymasınlar diye. Pil alanları `GET /standTalep/detay`'da YOK, bu
 * yüzden standOverviewService.getStandOverviewDetail o standın roster satırını
 * (`GET /standTalep/list` + search) ayrıca çekip detayın üstüne seriyor.
 */
/*
 * 2026-10-24 (backlog #209 / #210 / #211) - the Proje Bilgiler tab:
 *   #209 the "Kroki" tab is gone (commented out below, WAS notes): the stand's own plan and its place in the hall are the
 *        "Stand Planı" section (Components/Kroki/StandPlanBolumu.jsx) at the bottom of this tab; no demo-plan fallback.
 *   #210 the gray pill row is gone from this tab (StandListPage still uses it); what only the pills showed is a tile of
 *        Proje Bilgileri now, and "Proje Bilgilerini Düzenle" (Components/Projects/ProjeBilgiDuzenleModal.jsx) edits the
 *        project's stand type, height band and accepted height (PUT /projects/{id}).
 *   #211 each document card (Statik Hesap, Proje Görselleri, Teknik Talep Planı) lists its files with the status, the
 *        upload date, the reviewer and the open revisions (Components/Projects/DosyaTakip.jsx).
 *   #213 Proje Evrakları: the document groups keep the company portal's cards (status tile, file tiles, revision badge); the
 *        group's Uygun / Red sit on the card (they decide the whole title and drive the permit), every file tile opens the
 *        file and is approved or rejected on its own, a rejection with the reason the company sees (PUT /projects/{id}/files/{fileId}/approval),
 *        and the #211 tracking list sits under each group.
 *   #217 Proje Durumu (a live stand): the commitment workflow of the backend (#216 / #505) as it is - GET /projects/{id}/taahhutnameler drawn by
 *        Components/Projects/TaahhutnameDurumuPaneli.jsx: the source to choose, the generated page, the company's approval with who / when,
 *        the signed copy approved or rejected here, the electrician's signature, the trail. deriveCommitmentStage / synthesizeCommitments
 *        and the roster tiles now serve the mock stands only.
 */
import React, { useEffect, useId, useRef, useState } from "react";
import { useParams, useNavigate, useLocation, useSearchParams } from "react-router-dom";
import {
  Container, Card, CardBody, CardHeader, Row, Col, Badge, Nav, NavItem, NavLink, Spinner, Alert, Button,
  UncontrolledPopover, PopoverHeader, PopoverBody,
  Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input,
} from "reactstrap";
import {
  ArrowLeft, Box, Zap, Eye, Ruler, Maximize2, Layers3, Building2, Package,
  Check, X, Clock, FilePlus2, Image as ImageIcon, Star, Coins,
  AlertTriangle, Trash2, Plus, Lock, Unlock, ClipboardCheck, Printer, ShieldCheck,
  HardHat, Snowflake, FileCheck2, Pencil, Flag, Globe, Puzzle, Layers,
} from "lucide-react";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DocumentPreviewModal from "../../../Components/Common/DocumentPreviewModal";
// WAS (until #209, the Kroki tab embedded the whole hall):
// import KrokiVectorEmbed from "../../../Components/Kroki/KrokiVectorEmbed";
// import { resolveStandPlanDocument } from "../../../services/krokiVectorService";
import StandPlanBolumu from "../../../Components/Kroki/StandPlanBolumu";
import ProjeBilgiDuzenleModal from "../../../Components/Projects/ProjeBilgiDuzenleModal";
import { StandTypeRows } from "../../../Components/Projects/StandTypeAgaclari";
import DosyaTakip from "../../../Components/Projects/DosyaTakip";
import TaahhutnameDurumuPaneli from "../../../Components/Projects/TaahhutnameDurumuPaneli";
import {
  filesOfTitle, angleEntries, versionEntries, titleDecision, openDocumentRevisions,
  staffNameMap, needsReviewerNames, latestFile,
} from "../../../Components/Projects/dosyaTakipYardimci";
import { getStaffUsers } from "../../../services/userService";
import profileBg from "../../../assets/images/profile-bg.jpg";
import {
  getStandOverviewDetail, setUploadedFileApproval, chooseFileForCommitment,
  setUploadedFileReview,
  COMMITMENT_STATE, resolvePillLabel,
} from "../../../services/standOverviewService";
// Bilgi pilleri / izin rozetleri Stand Listesi ile PAYLAŞILIYOR — iki sayfa aynı
// standa farklı şeyler yazmasın diye tek dosyada tanımlı, bkz. StandPills.jsx.
import {
  // WAS (until #210, the gray pill row of the info tab): StandBadgeRowFull,
  STAND_CATEGORY_LABELS, PROJECT_TYPE_LABELS, PROJECT_STRUCTURE_LABELS,
  permitBadge, workPermitBadge, hasIssue,
  StandExtraInfoIndicator, stripParallelTreeMarker,
  StatusTile, statusBackground, NEUTRAL_GRAY, COMMITMENT_ICONS,
} from "../../../Components/Projects/StandPills";
import {
  getStandTypePath, FILE_APPROVAL_STATUS,
  getProjectByStandId, createRevision, deleteRevision, getRevisableFields,
  REVISION_TARGET_KIND, REVISION_STATUS, REVISION_OPENED_BY, isRevisionUnfinished,
  getProjeGorselleriCorners, getProjectFileUrl,
  getTaahhutnameler, recordElektrikciImzasi, setElektrikciFotografi, removeElektrikciImzasi,
  getStandTypes, getStandHeights, pickHeightBand, heightBandChoices, createProject, assignProjectSystem, overrideHeightLock,
  getAcceptedHeight, isDeclarationAccepted,
  getProjectDeclarationForms, blockingDeclarationForms, BEYAN_FORM_TIPI,
  decideOzelIzin, OZEL_IZIN_NOT_MAX,
} from "../../../services/projectService";
import KuralIhlalListesi from "../../../Components/Projects/KuralIhlalListesi";
import { describeHeightLimit } from "../../../services/fuarKuralService";
import { getEffectiveRequiredFiles, REQUIRED_FILES_LEVEL_LABELS } from "../../../services/belgeKuralService";
import { useTranslation } from "react-i18next";
import i18n, { currentLocaleTag } from "../../../i18n";

// Mock stand id'leri Mongo-tarzı hex string'lerdir ("665f..."); gerçek backend'in
// standId'leri sayısaldır. Bu basit ayrım, standOverviewService/projectService'in
// forceLive köprüsünü hangi standlar için açacağımızı route param'dan anlamamızı
// sağlıyor. Stand Listesi artık canlı test fuarlarında (298/299) gerçek standId'lerle
// link veriyor, ama mock fuarlar hâlâ hex id ürettiği için iki mod da destekleniyor.
const isNumericStandId = (v) => /^\d+$/.test(String(v));

// "Proje Türü"/"Kat Bilgisi" için hangi standTypeId'nin ağaç kırıntısını
// göstereceğimize karar verir. Sistem Ataması bekleniyorken projenin kendi
// standTypeId'si hâlâ genel kök tiptir (ör. "Paket Stand") — dekoratörün asıl
// seçtiği tip sadece declaredStandTypeId'de var, o yüzden onu tercih ederiz.
// Atama tamamlandıktan sonra ise assign-system standTypeId'yi declaredStandTypeId
// ile eşitler (staff düzeltmediyse) — ama düzelttiyse (bkz. stand 57552 fixture,
// util/knowledgebase/local-backend-testing.md) projenin kendi standTypeId'si asıl
// doğru/güncel değer, declaredStandTypeId artık eskimiş olabilir.
function resolveTargetStandTypeId(bridgedProject) {
  const pb = bridgedProject?.projeBeyani;
  return pb?.awaitingSystemAssignment
    ? (pb?.declaredStandTypeId ?? bridgedProject?.standTypeId)
    : (bridgedProject?.standTypeId ?? pb?.declaredStandTypeId);
}

// standTypePath'teki her kırıntı (kök→...→yaprak) Proje Bilgileri'nde ayrı bir
// kutucuk olarak gösterilir — hiçbir seviye diğerinin yerine geçmez (ör. "Paket
// Stand" kökü, "Tek Katlı" kat kategorisi, "Maxima Kare Profil" materyal/alt tip
// hepsi birden görünür). Bugüne kadar canlı ağaçlar hep 3 seviye (kök→kat→yaprak,
// bkz. FE-ProjectController-catalog-guide.md), ama katalog daha derin bir dal
// eklerse seviye 4+ de genel bir etiketle düşmeden gösterilsin diye fallback var.
const TYPE_LEVEL_LABELS = { get 1() { return i18n.t("projeler:standOverviewDetail.projeTuru"); }, get 2() { return i18n.t("projeler:standOverviewDetail.katBilgisi"); }, get 3() { return i18n.t("projeler:standOverviewDetail.materyal"); } };
const TYPE_LEVEL_ICONS = { 1: Layers3, 2: Building2, 3: Package };
function typeLevelLabel(level) {
  return TYPE_LEVEL_LABELS[level] ?? `Alt Tip (Seviye ${level})`;
}
function typeLevelIcon(level) {
  return TYPE_LEVEL_ICONS[level] ?? Package;
}

/**
 * Dekoratörün beyan ettiği YAPI ÖZELLİKLERİ tek satırda — 2026-08-24'te beyan
 * yalnızca tip+yükseklik olmaktan çıkıp m²/kW/cam/boya'yı da kapsadı (bkz.
 * docs/guides/FE-fuar-kural-sistemi-guide.md).
 *
 * ⚠️ null ≠ 0 ≠ false, ve bu üçünü aynı göstermek burada gerçek bir yanlış bilgi olur:
 *   · declaredKw null  = "elektrik istemiyorum"; 0 basmak sahte bir "0 kW" rozeti olurdu
 *   · declaredGlass null = fuar camı hiç SORMUYOR (camSorulsun kapalı) — "hayır" değil
 *   · declaredGlass false = soruldu, dekoratör hayır dedi
 */
function DeclaredSpecStrip({ pb }) {
  const { t } = useTranslation("projeler");
  if (!pb) return null;
  const items = [
    { label: t("standOverviewDetail.yukseklik"), value: pb.declaredHeightNumber == null ? "—" : `${pb.declaredHeightNumber} m` },
    { label: t("standOverviewDetail.alan"), value: pb.declaredAreaM2 == null ? "—" : `${pb.declaredAreaM2} m²` },
    // WAS: value: pb.declaredKw == null ? "Talep yok" : …   /   value: … == null ? "Sorulmadı" : … ? "Var" : "Yok"
    // #349: these values are shown, not stored (the extractor took the `value` key for data).
    { label: t("standOverviewDetail.elektrik"), value: pb.declaredKw == null ? t("standOverviewDetail.talepYok") : `${pb.declaredKw} kW` },
    { label: t("standOverviewDetail.cam"), value: pb.declaredGlass == null ? t("standOverviewDetail.sorulmadi") : pb.declaredGlass ? t("standOverviewDetail.var") : t("standOverviewDetail.yok") },
    { label: t("standOverviewDetail.boya"), value: pb.declaredPaint == null ? t("standOverviewDetail.sorulmadi") : pb.declaredPaint ? t("standOverviewDetail.var") : t("standOverviewDetail.yok") },
  ];
  return (
    <div className="d-flex flex-wrap gap-3 mb-3">
      {items.map((it) => (
        <div key={it.label} className="border rounded-2 px-3 py-2">
          <div className="text-muted" style={{ fontSize: 11 }}>{it.label}</div>
          <div className="fw-semibold small">{it.value}</div>
        </div>
      ))}
    </div>
  );
}

// "Proje Taahütnameleri" ve eskiden boş olan "Proje Durumu" sekmeleri birleştirildi
// — tek sekme "Proje Durumu" etiketiyle taahhütname içeriğini gösteriyor, ayrı
// bir durum sekmesi kalmadı. İç key ("commitments") değişmedi.
// "revisions": standId köprüsüyle bulunan projectService.js kaydının revizyon
// konuşmaları — bkz. yukarıdaki 2026-07-18 notu.
// "Kroki" sekmesindeki gömülü stand planının, standın kendi salonunda kroki YOKKEN
// düşeceği tanıtım dokümanı. fdsvector'de fuar 294 / salon 705 → "1.SALON DENEME":
// çizilmiş tek gerçek salon — Stands katmanında ~150 stand dikdörtgeni + duvarlar.
// (Aynı fuarın 706'sı "Test Bilge" sadece 8 şekillik karalama, 707 "3 Floor Plan"
// tamamen boş — bkz. util/knowledgebase/fdsvector-kroki-embed.md.)
// WAS (until #209): const ORNEK_STAND_PLAN = { fairId: 294, hallId: 705, ad: "1.SALON DENEME" };

const TABS = [
  { key: "info", get label() { return i18n.t("projeler:standOverviewDetail.projeBilgiler"); } },
  // WAS (until #209, the plan is a section of the info tab now): { key: "kroki", get label() { return i18n.t("projeler:standOverviewDetail.kroki"); } },
  { key: "files", get label() { return i18n.t("projeler:standOverviewDetail.projeEvraklari"); } },
  { key: "commitments", get label() { return i18n.t("projeler:standOverviewDetail.projeDurumu"); } },
  { key: "revisions", get label() { return i18n.t("projeler:standOverviewDetail.revizyonlar"); } },
];

// Proje Görselleri — 4 zorunlu köşe fotoğrafı + kuşbakışı, kroki karesine yerleşir.
// Mock modda standFileId 5 üzerinde ordinal (1-4) subStandFileId kullanılır (aşağıdaki
// ANGLES, dokunulmadı). Canlı modda gerçek köşeler standFileId 2'de, subStandFileId
// olarak ayrı bir file_type tablosunun id'lerini taşır (bkz. projectService.js
// getProjeGorselleriCorners) — isimle çözülüp CORNER_POSITIONS'daki 5 konuma sırayla
// eşlenir, hiçbir yerde sabit sayı gömülmez.
const ANGLES = [
  { key: "topLeft", subStandFileId: 1, get label() { return i18n.t("projeler:standOverviewDetail.solUst"); }, style: { top: 4, left: 4 } },
  { key: "topRight", subStandFileId: 2, get label() { return i18n.t("projeler:standOverviewDetail.sagUst"); }, style: { top: 4, right: 4 } },
  { key: "bottomLeft", subStandFileId: 3, get label() { return i18n.t("projeler:standOverviewDetail.solAlt"); }, style: { bottom: 4, left: 4 } },
  { key: "bottomRight", subStandFileId: 4, get label() { return i18n.t("projeler:standOverviewDetail.sagAlt"); }, style: { bottom: 4, right: 4 } },
];

const CORNER_POSITIONS = [
  { key: "topLeft", style: { top: 4, left: 4 } },
  { key: "topRight", style: { top: 4, right: 4 } },
  { key: "bottomLeft", style: { bottom: 4, left: 4 } },
  { key: "bottomRight", style: { bottom: 4, right: 4 } },
  { key: "aerial", style: { top: "50%", left: "50%", transform: "translate(-50%, -50%)" } },
];

// Renkler, kare ölçüsü ve ikon boyutu artık StandPills'ten geliyor (yukarıdaki
// import) — referans /Firma/Projeler'in StatusTile'ı. Buradaki yerel STATUS_HEX
// kopyası kaldırıldı; `secondary`/`primary` de bilerek gitti, ikisi de nötr griye
// düşüyor (firma tarafındaki aynı tercih).

function fmtDate(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString(currentLocaleTag(), { day: "2-digit", month: "short", year: "numeric" });
}

// Revizyon konuşmaları için — aynı gün içinde birden fazla mesaj gelebildiğinden
// fmtDate'in aksine saat:dakika da gösterir.
function fmtDateTime(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString(currentLocaleTag(), {
    day: "2-digit", month: "short", year: "numeric",
    hour: "2-digit", minute: "2-digit",
  });
}

// Canlı modda "commitments" (İSG/Statik/Elektrik taahhütname) backend'de ayrı bir alan
// değil — standFileId 5 (Taahütnameler) altındaki uploadedFiles, subStandFileId
// ordinaline (1 Statik/2 İSG/3 Elektrik) göre gruplanarak SENTEZLENİR (bkz.
// docs/guides/FE-ProjectController-beyani-revisions-guide.md "5 Taahütnameler (sub
// 1 Statik/2 İSG/3 Elektrik)"). Mock veri bu alanı doğrudan taşıdığı için bu sadece
// bridgedProject varken (canlı köprü bulunduğunda) devreye girer.
const TAAHHUT_SUBIDS = [
  { key: "statik", subStandFileId: 1, get label() { return i18n.t("projeler:standOverviewDetail.statikTaahutname"); } },
  { key: "isg", subStandFileId: 2, get label() { return i18n.t("projeler:standOverviewDetail.isgTaahutname"); } },
  { key: "elektrik", subStandFileId: 3, get label() { return i18n.t("projeler:standOverviewDetail.elektrikTaahutname"); } },
];

// Taahhütname akışı: dekoratör yükler → inceleyen kişi burada "ana belge" seçer
// (PUT .../choose — "Marks one file as the one used for PDF generation") →
// dekoratör belgeyi yazdırıp imzalayıp aynı alt-tipe TEKRAR yükler → inceleyen
// kişi bu ikinci (imzalı) dosyayı da seçer → tamamlandı. `choosenToGenerate`
// backend'de TÜM standFileId 5 başlığı için tek seferde sıfırlanır (bkz.
// FE-ProjectController-project-guide.md "/choose" side effect 1), bu yüzden bu
// alt-tipe özel kalıcı sinyal her dosyanın KENDİ approvalStatus'udur (sadece
// choose ile 1 olur, sonraki başka bir choose çağrısıyla sıfırlanmaz) —
// FirmaStandDetailPage.jsx'teki (dekoratör tarafı) aynı isimli dosya-yerel kopya.
function deriveCommitmentStage(files) {
  if (!files || files.length === 0) return "empty";
  const latest = files[files.length - 1];
  const anyApprovedBeforeLatest = files.slice(0, -1).some((f) => f.approvalStatus === 1);
  if (latest.approvalStatus === 1) return anyApprovedBeforeLatest ? "done" : "generated";
  return anyApprovedBeforeLatest ? "signedUploaded" : "draft";
}

const COMMITMENT_STAGE_META = {
  empty:          { get label() { return i18n.t("projeler:standOverviewDetail.belgeYok"); },                                color: "secondary" },
  draft:          { get label() { return i18n.t("projeler:standOverviewDetail.yuklendiSecimBekliyor"); },                color: "warning" },
  generated:      { get label() { return i18n.t("projeler:standOverviewDetail.anaBelgeSecildiImzaliBekleniyor"); },    color: "info" },
  signedUploaded: { get label() { return i18n.t("projeler:standOverviewDetail.imzaliBelgeYuklendiSonOnay"); }, color: "warning" },
  done:           { get label() { return i18n.t("projeler:standOverviewDetail.tamamlandi"); },                                color: "success" },
};

function synthesizeCommitments(uploadedFiles, fileApprovals) {
  return TAAHHUT_SUBIDS.map(({ key, subStandFileId, label }) => {
    const files = (uploadedFiles || [])
      .filter((f) => f.standFileId === 5 && f.subStandFileId === subStandFileId && !f.deleted)
      .sort((a, b) => new Date(a.uploadedAt) - new Date(b.uploadedAt));
    return { key, subStandFileId, label, files, stage: deriveCommitmentStage(files) };
  });
}

// ─── Kroki: grid arka plan + L şeklinde stand poligonu (mock kroki görseli) ───
function KrokiGrid({ children, size = 130 }) {
  const gridId = useId();
  return (
    <div className="position-relative" style={{ width: size, height: size }}>
      <svg viewBox="0 0 120 120" width={size} height={size}>
        <defs>
          <pattern id={gridId} width="15" height="15" patternUnits="userSpaceOnUse">
            <path d="M 15 0 L 0 0 0 15" fill="none" stroke="#d7dfe3" strokeWidth="1" />
          </pattern>
        </defs>
        <rect width="120" height="120" fill={`url(#${gridId})`} />
        <polygon
          points="10,10 65,10 65,65 110,65 110,110 10,110"
          fill="#178f8f"
          stroke="#0c5f5f"
          strokeWidth="1.5"
        />
      </svg>
      {children}
    </div>
  );
}

// WAS: function RequiredFileRibbon({ label, center = true, children }) {
// #210: `action` = a button at the top right of the card ("Proje Bilgilerini Düzenle").
function RequiredFileRibbon({ label, center = true, action = null, children }) {
  return (
    <Card className="position-relative overflow-hidden h-100">
      <span
        className="badge bg-danger position-absolute text-white"
        style={{
          top: 12, left: -6, padding: "4px 16px 4px 10px",
          clipPath: "polygon(0 0, 100% 0, 88% 50%, 100% 100%, 0 100%)",
          fontSize: "0.7rem", zIndex: 2,
        }}
      >
        {label}
      </span>
      {action ? <div className="position-absolute" style={{ top: 8, right: 10, zIndex: 2 }}>{action}</div> : null}
      <CardBody className={`pt-4 ${center ? "d-flex flex-column align-items-center" : ""}`}>{children}</CardBody>
    </Card>
  );
}

// WAS: function StatikOrElektrikCard({ label, icon: Icon, approvalStatus }) {
// #211: `tracking` = the file tracking list (DosyaTakip) under the status badge.
function StatikOrElektrikCard({ label, icon: Icon, approvalStatus, tracking = null }) {
  const { t } = useTranslation("projeler");
  const info = FILE_APPROVAL_STATUS[approvalStatus] ?? { label: t("standOverviewDetail.beklemede"), color: "warning" };
  return (
    <RequiredFileRibbon label={label}>
      <KrokiGrid>
        <div className="position-absolute top-50 start-50 translate-middle">
          <StatusTile icon={Icon} color={info.color} label={info.label} />
        </div>
      </KrokiGrid>
      <Badge color={info.color} className="mt-2">{info.label}</Badge>
      {tracking}
    </RequiredFileRibbon>
  );
}

// WAS: function ProjeGorselleriCard({ uploadedFiles, standFileId, angles }) {
function ProjeGorselleriCard({ uploadedFiles, standFileId, angles, tracking = null }) {
  const { t } = useTranslation("projeler");
  // WAS: const byAngle = (subId) => uploadedFiles.find((u) => u.standFileId === standFileId && u.subStandFileId === subId);
  // #211: the NEWEST not-deleted upload of the corner - the first match was the oldest, so a corner uploaded again after a rejection kept showing the rejected file.
  const byAngle = (subId) => latestFile(uploadedFiles.filter((u) => u.standFileId === standFileId && u.subStandFileId === subId));
  return (
    <RequiredFileRibbon label={t("standOverviewDetail.projeGorselleri")}>
      <KrokiGrid>
        {angles.map((a) => {
          const file = byAngle(a.subStandFileId);
          const info = file ? (FILE_APPROVAL_STATUS[file.approvalStatus] ?? FILE_APPROVAL_STATUS[0]) : null;
          return (
            <div
              key={a.key}
              className="position-absolute d-flex align-items-center justify-content-center rounded-circle"
              style={{
                width: 26, height: 26,
                // Köşe pinleri kroki ızgarasına (130px) konumlanmış İŞARETLER —
                // 40px kareye büyütmek ızgarayı taşırırdı, o yüzden ölçü/biçim
                // korunuyor; RENK paylaşılan paletten.
                background: info ? statusBackground(info.color) : NEUTRAL_GRAY,
                opacity: file ? 1 : 0.5,
                ...a.style,
              }}
              title={`${a.label}: ${file ? file.originalFileName : t("standOverviewDetail.yuklenmedi")}`}
            >
              <Eye size={13} color="#fff" />
            </div>
          );
        })}
      </KrokiGrid>
      <div className="text-muted small mt-2">{angles.length}{" "}{t("standOverviewDetail.acidanZorunluFotograf")}</div>
      {tracking}
    </RequiredFileRibbon>
  );
}

// ─── Proje Evrakları sekmesi: belge tipi başına satır (durum + yüklenen dosyalar) ───
// Mock veri standFileId 2=Statik Hesap / 5=Proje Görselleri varsayıyordu — gerçek
// katalog farklı (bkz. GET /projects/stand-files-classic, docs/BACKEND_TODO.md):
// 2=3-D Görseller (Proje Görselleri, köşe alt-tipleriyle — ayrıca bkz. ProjeGorselleriCard),
// 3=Elektrik Planı, 7=Statik Hesap Bilgisi. 5=Taahütnameler artık ayrı "Proje Durumu"
// sekmesinin konusu (bkz. commitments), burada tekrar listelenmiyor.
const DOC_GROUPS = [
  { standFileId: 2, get label() { return i18n.t("projeler:standOverviewDetail.projeGorselleri"); } },
  { standFileId: 3, get label() { return i18n.t("projeler:standOverviewDetail.teknikTalepPlani"); } },
  { standFileId: 7, get label() { return i18n.t("projeler:standOverviewDetail.statikHesap"); } },
];

// Proje Görselleri (mock: standFileId 5, canlı: standFileId 2) satırındaki dosyaların
// hover etiketi. Mock modda subStandFileId 1-4 sabit köşe sırasıdır. Canlı modda
// subStandFileId gerçek file_type id'sidir (bkz. getProjeGorselleriCorners) — sabit
// sayı gömmemek için ad eşlemesi çağıran yerde (liveCornerLabels state) kurulur.
const PROJE_GORSELLERI_ANGLE_LABELS = {
  get 1() { return i18n.t("projeler:standOverviewDetail.solUst"); },
  get 2() { return i18n.t("projeler:standOverviewDetail.sagUst"); },
  get 3() { return i18n.t("projeler:standOverviewDetail.solAlt"); },
  get 4() { return i18n.t("projeler:standOverviewDetail.sagAlt"); },
};

function fileKind(name) {
  return /\.(jpe?g|png|gif)$/i.test(name || "") ? "image" : "pdf";
}

function FileStatusBadge({ status }) {
  const info = FILE_APPROVAL_STATUS[status] ?? FILE_APPROVAL_STATUS[0];
  const Icon = status === 1 ? Check : status === 2 ? X : Clock;
  return (
    <div
      className="position-absolute d-flex align-items-center justify-content-center rounded-circle border border-2 border-white"
      // Dosya küçük resminin köşesine iliştirilen işaret — durum karesi değil,
      // bu yüzden 18px daire kalıyor; rengi paylaşılan paletten.
      style={{ width: 18, height: 18, top: -6, right: -6, background: statusBackground(info.color) }}
      title={info.label}
    >
      <Icon size={10} color="#fff" strokeWidth={3} />
    </div>
  );
}

// WAS (until #213): function FileTile({ file, angleLabel, commitments, actionLoading, onSetApproval, onChooseCommitment }) {
// #213: the tile's own Approve / Reject (per file, the rejection with its reason) and Open replace the title-level Uygun / Red
// that used to sit in this popover (they are on the document group's card now, see DocGroupRow).
function FileTile({ file, angleLabel, commitments, actionLoading, onReviewFile, onPreview, onChooseCommitment }) {
  const { t } = useTranslation("projeler");
  const [rejecting, setRejecting] = useState(false);
  const [reason, setReason] = useState("");
  const kind = fileKind(file.originalFileName);
  const domId = `file-tile-${file.id}`;
  const hoverTitle = angleLabel ? `${angleLabel} — ${file.originalFileName}` : file.originalFileName;
  return (
    <div className="position-relative" title={hoverTitle}>
      <div
        id={domId}
        role="button"
        tabIndex={0}
        className="d-flex align-items-center justify-content-center rounded-3 text-white fw-bold"
        style={{ width: 46, height: 46, background: "#0f6d6d", fontSize: kind === "pdf" ? "0.65rem" : undefined, cursor: "pointer" }}
      >
        {kind === "pdf" ? t("standOverviewDetail.pdf") : <ImageIcon size={20} />}
      </div>
      <FileStatusBadge status={file.approvalStatus} />
      {(file.isChosen ?? file.choosenToGenerate) && (
        <span
          className="position-absolute d-flex align-items-center justify-content-center rounded-circle bg-primary border border-2 border-white"
          style={{ width: 18, height: 18, bottom: -6, left: -6 }}
          title={t("standOverviewDetail.birProjeTaahutnamesiIcinAna")}
        >
          <Star size={10} color="#fff" strokeWidth={3} />
        </span>
      )}
      <UncontrolledPopover target={domId} trigger="legacy" placement="top">
        <PopoverHeader>{angleLabel ?? file.originalFileName}</PopoverHeader>
        <PopoverBody style={{ minWidth: 230 }}>
          {/* WAS (until #213; the title-level decision is on the document group's card now):
          <div className="d-flex gap-2 mb-2">
            <Button
              color="success" size="sm" outline={file.approvalStatus !== 1} disabled={actionLoading}
              onClick={() => onSetApproval(file.id, 1)}
            >
              <Check size={12} className="me-1" />{" "}{t("standOverviewDetail.uygun")}
            </Button>
            <Button
              color="danger" size="sm" outline={file.approvalStatus !== 2} disabled={actionLoading}
              onClick={() => onSetApproval(file.id, 2)}
            >
              <X size={12} className="me-1" />{" "}{t("standOverviewDetail.red")}
            </Button>
          </div> */}
          {onPreview && (
            <Button color="light" size="sm" className="mb-2" onClick={() => onPreview(file)} data-testid="dosya-ac">
              <Eye size={12} className="me-1" />{" "}{t("standOverviewDetail.dosyayiAc")}
            </Button>
          )}
          {onReviewFile && (
            <>
              <div className="small text-muted mb-1">{t("standOverviewDetail.dosyaIncelemesi")}</div>
              <div className="d-flex gap-2 mb-2">
                <Button
                  color="success" size="sm" outline={file.approvalStatus !== 1} disabled={actionLoading}
                  onClick={() => { setRejecting(false); onReviewFile(file.id, 1); }}
                  data-testid="dosya-onayla"
                >
                  <Check size={12} className="me-1" />{" "}{t("standOverviewDetail.dosyayiOnayla")}
                </Button>
                <Button
                  color="danger" size="sm" outline={file.approvalStatus !== 2} disabled={actionLoading}
                  onClick={() => setRejecting(true)}
                  data-testid="dosya-reddet"
                >
                  <X size={12} className="me-1" />{" "}{t("standOverviewDetail.dosyayiReddet")}
                </Button>
              </div>
              {rejecting && (
                <div className="mb-2" data-testid="dosya-red-formu">
                  <Input
                    type="textarea" rows="2" value={reason} maxLength={500}
                    placeholder={t("standOverviewDetail.redGerekcesiPlaceholder")}
                    onChange={(e) => setReason(e.target.value)}
                    data-testid="dosya-red-gerekce"
                  />
                  <div className="d-flex gap-2 mt-1">
                    <Button
                      color="danger" size="sm" disabled={actionLoading}
                      onClick={async () => { await onReviewFile(file.id, 2, reason.trim()); setRejecting(false); setReason(""); }}
                      data-testid="dosya-red-kaydet"
                    >
                      {t("standOverviewDetail.reddiKaydet")}
                    </Button>
                    <Button color="light" size="sm" onClick={() => { setRejecting(false); setReason(""); }}>{t("common:iptal")}</Button>
                  </div>
                </div>
              )}
            </>
          )}
          {commitments.length > 0 && (
            <>
              <div className="small text-muted mb-1">{t("standOverviewDetail.taahhutnameIcinAnaBelgeYap")}</div>
              <div className="d-flex flex-column gap-1">
                {commitments.map((c) => {
                  const active = c.fileId === file.id;
                  return (
                    <Button
                      key={c.key} color={active ? "primary" : "light"} size="sm" disabled={actionLoading}
                      className="text-start"
                      onClick={() => onChooseCommitment(c.key, file.id)}
                    >
                      {active && <Check size={11} className="me-1" />}{c.label}
                    </Button>
                  );
                })}
              </div>
            </>
          )}
        </PopoverBody>
      </UncontrolledPopover>
    </div>
  );
}

// WAS (until #213): function DocGroupRow({ label, standFileId, overallStatus, files, commitments, actionLoading, onSetApproval, onChooseCommitment, openRevision, onShowRevision, angleLabels }) {
// #213: `onSetApproval(fileId, status)` is the whole title's decision (the group's Uygun / Red, on the card), `onReviewFile` one file's,
// `tracking` the #211 list (DosyaTakip).
function DocGroupRow({ label, standFileId, overallStatus, files, commitments, actionLoading, onSetApproval, onReviewFile, onPreview, onChooseCommitment, openRevision, onShowRevision, angleLabels, tracking = null }) {
  const { t } = useTranslation("projeler");
  const overallInfo = FILE_APPROVAL_STATUS[overallStatus] ?? FILE_APPROVAL_STATUS[0];
  const OverallIcon = overallStatus === 1 ? Check : overallStatus === 2 ? X : Clock;
  const groupFile = files.find((f) => !f.deleted) ?? null;
  const groupAction = onSetApproval && groupFile ? (
    <div className="d-flex gap-1" data-testid="grup-onay">
      <Button
        color="success" size="sm" outline={overallStatus !== 1} disabled={actionLoading || overallStatus === 1}
        title={t("standOverviewDetail.belgeGrubunuOnayla")} onClick={() => onSetApproval(groupFile.id, 1)}
        data-testid="grup-onayla"
      >
        <Check size={12} className="me-1" />{" "}{t("standOverviewDetail.uygun")}
      </Button>
      <Button
        color="danger" size="sm" outline={overallStatus !== 2} disabled={actionLoading || overallStatus === 2}
        title={t("standOverviewDetail.belgeGrubunuReddet")} onClick={() => onSetApproval(groupFile.id, 2)}
        data-testid="grup-reddet"
      >
        <X size={12} className="me-1" />{" "}{t("standOverviewDetail.red")}
      </Button>
    </div>
  ) : null;
  return (
    <RequiredFileRibbon label={label} center={false} action={groupAction}>
      <div className="d-flex align-items-center gap-3 flex-wrap">
        <StatusTile icon={OverallIcon} color={overallInfo.color} label={`${label} — ${overallInfo.label}`} />
        {openRevision && (
          <Badge
            color="danger"
            className="flex-shrink-0"
            style={{ cursor: "pointer" }}
            title={t("standOverviewDetail.acikRevizyonIstegiGoruntulemekIcin")}
            onClick={() => onShowRevision(openRevision)}
          >
            <AlertTriangle size={11} className="me-1" />‼
          </Badge>
        )}
        <div className="vr" style={{ height: 40 }} />
        <Button
          color="dark" outline size="sm" disabled title={t("standOverviewDetail.yeniDosyaEkleYakinda")}
          className="d-flex align-items-center justify-content-center flex-shrink-0"
          style={{ width: 40, height: 40 }}
        >
          <FilePlus2 size={18} />
        </Button>
        {files.length === 0 ? (
          <span className="text-muted small">{t("standOverviewDetail.henuzDosyaYuklenmedi")}</span>
        ) : (
          files.map((f) => (
            <FileTile
              key={f.id}
              file={f}
              angleLabel={angleLabels ? angleLabels[f.subStandFileId] : null}
              commitments={commitments}
              actionLoading={actionLoading}
              onReviewFile={onReviewFile}
              onPreview={onPreview}
              onChooseCommitment={onChooseCommitment}
            />
          ))
        )}
      </div>
      {tracking}
    </RequiredFileRibbon>
  );
}

// ─── Proje Taahütnameleri sekmesi: inşaat izni özeti + taahhütname durumları ───
// Dekoratörün standFileId 5/subStandFileId'ye yüklediği TÜM dosyaları listeler
// (genelde 1 — taslak, veya 2 — taslak + imzalı) ve inceleyen kişiye en son
// dosyayı taahhütname için "seç" imkânı verir (bkz. dosya başı deriveCommitmentStage
// notu). `stage` "generated" iken sıradaki adım dekoratöre ait (imzalı belgeyi
// yüklemesi) — burada gösterilecek bir aksiyon yok, sadece bekleme durumu.
const COMMITMENT_STAGE_ICON = {
  empty: Clock, draft: Clock, generated: Printer, signedUploaded: Clock, done: Check,
};

function CommitmentTile({ label, stage, files, actionLoading, onChoose, onPreview }) {
  const { t } = useTranslation("projeler");
  const stageMeta = COMMITMENT_STAGE_META[stage] ?? COMMITMENT_STAGE_META.empty;
  const Icon = COMMITMENT_STAGE_ICON[stage] ?? Clock;
  const latest = files && files.length > 0 ? files[files.length - 1] : null;
  // Sadece en son yüklenen dosya henüz onaylanmadıysa ("draft"/"signedUploaded")
  // seçilebilir — daha eski bir dosyayı seçmek akışı geriye sarar, kasıtlı olarak sunulmuyor.
  // onChoose verilmediyse (mock modda çağıran taraf bilerek geçmiyor) salt-okunur kalır.
  const canChoose = !!onChoose && latest && (stage === "draft" || stage === "signedUploaded");
  return (
    <Col md={4} className="text-center mb-3">
      <div className="d-inline-flex mb-2">
        <StatusTile icon={Icon} color={stageMeta.color} label={`${label} — ${stageMeta.label}`} />
      </div>
      <div className="small fw-semibold">{label}</div>
      <Badge color={stageMeta.color} className="mt-1 fw-normal">{stageMeta.label}</Badge>

      {latest ? (
        <div
          className="d-flex align-items-center justify-content-center gap-1 mt-2 text-muted small"
          style={{ cursor: onPreview ? "pointer" : undefined }}
          title={latest.originalFileName}
          onClick={onPreview ? () => onPreview(latest) : undefined}
        >
          <ImageIcon size={12} />
          <span className="text-truncate" style={{ maxWidth: 140 }}>{latest.originalFileName}</span>
        </div>
      ) : (
        <div className="text-muted small mt-1 fst-italic">{t("standOverviewDetail.belgeYuklenmedi")}</div>
      )}

      {stage === "generated" && (
        <div className="text-muted small mt-2 fst-italic">{t("standOverviewDetail.dekoratorunImzaliBelgeyiYuklemesiBekleniyor")}</div>
      )}

      {canChoose && (
        <Button
          color="primary" outline size="sm" className="mt-2" disabled={actionLoading}
          onClick={() => onChoose(latest.id)}
        >
          <Check size={13} className="me-1" />{" "}{t("standOverviewDetail.taahhutnameIcinSec")}
        </Button>
      )}
    </Col>
  );
}

/**
 * Taahhütname kutusu — roster'ın GERÇEK üretim zinciri şekli için
 * ({key,label,sourceStandFileId,sourceSubFileId,sourceName,state}).
 *
 * Yukarıdaki CommitmentTile'dan farkı, neyi anlattığı: o "standFileId 5'e hangi dosya
 * yüklendi, onaylandı mı" diye bakıyordu; bu ise zincirin nerede durduğunu okuyor.
 * Taahhütname YÜKLENMİYOR — KAYNAK belge yükleniyor (İSG←3D Köşe, Elektrik←Kuşbakışı,
 * Statik←Statik Hesap), inceleyen kişi doğru dosyayı seçiyor, sistemin üretmesi
 * gerekiyor. Bugün zincir CHOSEN'da duruyor (PDF üretimi henüz yok), o yüzden
 * GENERATED/SIGNATURE_REQUIRED pratikte görünmez ama ele alınıyor.
 *
 * Seçim aksiyonu: kaynak yüklenmiş ama henüz seçilmemişken (SOURCE_UPLOADED) aday
 * dosyalar `sourceStandFileId` başlığındaki yüklemelerden gelir. Backend'in ucu düz
 * bir toggle (PUT /projects/{id}/files/{fileId}/choose) — hangi taahhütname olduğunu
 * dosyanın kendi standFileId/subStandFileId'sinden çıkarıyor, commitmentKey göndermeye
 * gerek yok (bkz. standOverviewService.chooseFileForCommitment).
 */
function SourceCommitmentTile({ commitment, uploadedFiles, actionLoading, onChoose, onPreview }) {
  const { t } = useTranslation("projeler");
  const meta = COMMITMENT_STATE[commitment.state] ?? COMMITMENT_STATE.NO_SOURCE;
  const Icon = COMMITMENT_ICONS[commitment.key] ?? ClipboardCheck;
  // Aday kaynak dosyalar: taahhütnamenin beslendiği belge başlığına yüklenmiş,
  // silinmemiş her dosya. subStandFileId biliniyorsa (backend hangi alt tipi
  // beklediğini söylüyorsa) onunla daraltılır.
  const candidates = (uploadedFiles || []).filter((f) => (
    f.standFileId === commitment.sourceStandFileId
    && !f.deleted
    && (commitment.sourceSubFileId == null || f.subStandFileId === commitment.sourceSubFileId)
  ));
  // Seçilmiş kaynak dosya: backend `choosenToGenerate` bayrağını taşıyor. Tek aday
  // varsa o da yeterli bir tahmin — ama SADECE önizleme/ad göstermek için, seçim
  // kararı asla buradan türetilmez (o `state`'in işi).
  const chosen = candidates.find((f) => f.choosenToGenerate)
    ?? (candidates.length === 1 ? candidates[0] : null);
  // sourceName SADECE seçimden sonra doluyor; eski elle imzalanmış taahhütnamelerde
  // (state SIGNED, sourceStandFileId 5) hiç gelmiyor. O durumda dosyanın kendi adına
  // düşüyoruz — "adı okunamadı" demek yerine elimizdeki adı göstermek doğru.
  const sourceLabel = commitment.sourceName ?? chosen?.originalFileName ?? null;
  const canChoose = !!onChoose && commitment.state === "SOURCE_UPLOADED" && candidates.length > 0;
  return (
    <Col md={4} className="text-center mb-3">
      <div className="d-inline-flex mb-2">
        <StatusTile icon={Icon} color={meta.color} label={`${commitment.label} — ${meta.label}`} />
      </div>
      <div className="small fw-semibold">{commitment.label}</div>
      <Badge color={meta.color} className="mt-1 fw-normal">{meta.label}</Badge>

      {/* Kaynak belge adı backend'den geliyor (sourceName) — dosya listesini tekrar
          taramaya gerek yok, ve seçim başka bir oturumda yapıldıysa da doğru okunur.
          ⚠️ sourceName SADECE seçim yapıldıktan sonra doluyor; SOURCE_UPLOADED'da hâlâ
          null. Bu yüzden "ad yok" ile "belge yok" AYNI ŞEY DEĞİL — ikisini birleştirmek
          rozetin "Kaynak yüklendi" dediği kutuya "Kaynak belge yüklenmedi" yazdırıyordu. */}
      {sourceLabel ? (
        <div
          className="d-flex align-items-center justify-content-center gap-1 mt-2 text-muted small"
          style={{ cursor: onPreview && chosen ? "pointer" : undefined }}
          title={sourceLabel}
          onClick={onPreview && chosen ? () => onPreview(chosen) : undefined}
        >
          <ImageIcon size={12} />
          <span className="text-truncate" style={{ maxWidth: 150 }}>{t("standOverviewDetail.kaynak")}{" "}{sourceLabel}</span>
        </div>
      ) : commitment.state === "NO_SOURCE" ? (
        <div className="text-muted small mt-1 fst-italic">{t("standOverviewDetail.kaynakBelgeYuklenmedi")}</div>
      ) : (
        <div className="text-muted small mt-1 fst-italic">
          {candidates.length > 0
            ? t("standOverviewDetail.adayBelgeSecimBekliyor", { length: candidates.length })
            : t("standOverviewDetail.kaynakBelgeBuBasliktaBulunamadi")}
        </div>
      )}

      {canChoose && (
        <div className="d-flex flex-column align-items-center gap-1 mt-2">
          {candidates.map((f) => (
            <Button
              key={f.id}
              color="primary" outline size="sm" disabled={actionLoading}
              onClick={() => onChoose(commitment.key, f.id)}
              title={f.originalFileName}
            >
              <Check size={13} className="me-1" />
              <span className="text-truncate d-inline-block align-bottom" style={{ maxWidth: 120 }}>
                {f.originalFileName}
              </span>
            </Button>
          ))}
          <div className="text-muted fst-italic" style={{ fontSize: 11 }}>{t("standOverviewDetail.kaynakBelgeyiSecin")}</div>
        </div>
      )}

      {commitment.state === "GENERATED" && (
        <div className="text-muted small mt-2 fst-italic">{t("standOverviewDetail.dekoratorunImzaliBelgeyiYuklemesiBekleniyor")}</div>
      )}
    </Col>
  );
}

export default function StandOverviewDetailPage() {
  const { t: tx } = useTranslation("projeler");
  const { standId } = useParams();
  const navigate = useNavigate();
  // İki liste bu detayı açıyor: Standlar (/Management/Standlar) ve Projeler > Stand
  // Listesi. "Listeye Dön" geldiği listeye dönsün — Standlar listesi `state.from` verir.
  const location = useLocation();
  const backTo = location.state?.from || "/Management/Projects";

  const [stand, setStand] = useState(null);
  const [standTypeName, setStandTypeName] = useState(null);
  // Canlı modda "Proje Türü"/"Kat Bilgisi" için tam ağaç kırıntısı (root→kat
  // kategorisi→yaprak, bkz. aşağıdaki standTypePath effect'i).
  const [standTypePath, setStandTypePath] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // #283: Stand Listesi'ndeki dosya sayaçları bu sayfayı yeni sekmede ?tab=files / ?tab=revisions ile açar; geçersiz
  // ya da eksik değer "info"da kalır. Sekme değişince adrese YAZILMAZ (yalnızca açılış sekmesini seçer).
  const [searchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState(() => {
    const requested = searchParams.get("tab");
    return TABS.some((tb) => tb.key === requested) ? requested : "info";
  });
  const [actionLoading, setActionLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState(null);
  const [previewFile, setPreviewFile] = useState(null);

  // standId köprüsüyle bulunan projectService.js kaydı — bkz. dosya başı 2026-07-18
  // notu. Çoğu stand için null kalır (bağlı bir proje kaydı yoksa/bridge edilmediyse).
  const [bridgedProject, setBridgedProject] = useState(null);

  // Canlı mod (gerçek backend, forceLive) sadece sayısal standId'ler için — bkz. dosya
  // başındaki isNumericStandId notu. Mock Stand Listesi hâlâ Mongo-tarzı id'lerle
  // bağlantı kuruyor, bu yüzden bu sayfa iki modu da desteklemek zorunda.
  const isLiveStandId = isNumericStandId(standId);
  // Proje Görselleri köşe/kuşbakışı alt-tipleri — sadece canlı modda, bkz.
  // projectService.getProjeGorselleriCorners.
  const [liveCorners, setLiveCorners] = useState(null);

  // ─── Proje Kaydı Oluştur (staff, Proje Beyanı adım 1) — sadece canlı + proje
  // yokken: kök stand tipi (Paket/Özel/Pavilyon) + söz verilen yükseklik. Bkz.
  // FE-ProjectController-beyani-revisions-guide.md bölüm A.
  const [rootStandTypes, setRootStandTypes] = useState([]);
  const [shellStandTypeId, setShellStandTypeId] = useState("");
  const [creatingShell, setCreatingShell] = useState(false);

  // ─── Sistem Ataması (staff, adım 3) — dekoratör beyan ettikten sonra yükseklik
  // bandı. 2026-09-15: bant beyan yüksekliğinden OTOMATİK seçiliyor (pickHeightBand —
  // backend'de böyle bir eşleme yok, FE politikası); staff yalnızca "Değiştir" ile
  // elle seçer. assignHeightId "" = otomatik seçim geçerli.
  const [bandOptions, setBandOptions] = useState(null); // { typeId, list } | null
  const [assignHeightId, setAssignHeightId] = useState("");
  const [bandManual, setBandManual] = useState(false);
  const [assigningSystem, setAssigningSystem] = useState(false);

  // ─── Kilit Kaldırma (staff override). 2026-08-24: kilit artık yükseklik
  // uyuşmazlığından değil, fuar kural setinden geliyor (bkz. projectService.js
  // overrideHeightLock yorumu — HEIGHT_MISMATCH emekliye ayrıldı).
  const [overrideNote, setOverrideNote] = useState("");
  const [overridingLock, setOverridingLock] = useState(false);

  // Zorunlu belge listesini 5 seviyeli kaskadın HANGİSİ çözdü (bkz. belgeKuralService.js).
  const [requiredLevel, setRequiredLevel] = useState(null);

  // ─── assign-system'in İKİ YENİ ENGELİ (2026-08-28) ────────────────────────────
  // Backend, "Sistemi Onayla"yı artık iki yeni sebeple 400'lüyor ve ikisi de DÜZ
  // METİN dönüyor (violations dizisi YOK, parse etmeye çalışmayın):
  //   1. Projede ONAY BEKLEYEN bir Proje Özel İzni var. Bu, izin yolunun sıraya
  //      kaynak yapmasını engelliyor: birinin yargıladığı bir şartnameyi kabul etmek,
  //      onu sessizce onaylamak olurdu.
  //   2. Fuarın ZORUNLU beyan formlarından biri doldurulmamış. HEPSİ tek mesajda
  //      adlandırılıyor, ilki değil.
  // İkisi bağımsız; bir proje aynı anda ikisine de takılabilir ama backend önce
  // izni söyler. O yüzden ikisini de KENDİMİZ okuyup düğmeyi önden kapatıyoruz —
  // kullanıcı düz metin bir 400'den öğrenmesin.
  const [projectForms, setProjectForms] = useState([]);
  // Özel izin kararı burada da verilebiliyor (tepsi: /Management/Projects/SpecialPermits).
  const [permitDecision, setPermitDecision] = useState(null); // { onay } | null
  const [permitNote, setPermitNote] = useState("");
  const [permitBusy, setPermitBusy] = useState(false);

  // Revizyon: yeni konuşma modalı. 2026-08-25: artık üç hedef var (bkz.
  // projectService.js bölüm 9) — belge (DOCUMENT), beyan alanı (SPEC_FIELD) ve
  // serbest not (FREEFORM). Modal targetKind seçtirir, `type` ondan TÜRETİLİR:
  // belge → visual, diğer ikisi → structural.
  const [revisionModal, setRevisionModal] = useState(false);
  const [revisionTargetKind, setRevisionTargetKind] = useState("FREEFORM");
  const [revisionStandFileId, setRevisionStandFileId] = useState("");
  const [revisionFieldKey, setRevisionFieldKey] = useState("");
  const [revisionText, setRevisionText] = useState("");
  const [revisionScreenshot, setRevisionScreenshot] = useState(null);
  const screenshotInputRef = useRef();
  // Revize edilebilir beyan alanları — dropdown BUNDAN kurulur, sabit listeden
  // değil: listede olmayan bir key'i backend'in her revizyon ucu reddeder.
  const [revisableFields, setRevisableFields] = useState([]);
  // Revizyon: silme onayı
  const [deleteRevisionId, setDeleteRevisionId] = useState(null);
  // WAS (until #209): Kroki: standın kendi salonunda kroki var mı (bkz. aşağıdaki krokiKendiPlani türetmesi)
  // const [krokiProbe, setKrokiProbe] = useState(null);
  // #210: "Proje Bilgilerini Düzenle" penceresi.
  const [projeDuzenle, setProjeDuzenle] = useState(false);
  // #211: inceleyen kişilerin adları (kullanıcı id -> ad), GET /users/staff.
  const [staffNames, setStaffNames] = useState({});
  // #217: the generated taahhutnameler (GET /projects/{id}/taahhutnameler) of a live project; `taahhutYenile` is bumped to read them again.
  const [taahhut, setTaahhut] = useState(null);
  const [taahhutHata, setTaahhutHata] = useState(null);
  const [taahhutYenile, setTaahhutYenile] = useState(0);

  // Adım 3 bant seçimi — effect'lerden (zorunlu belge önizlemesi) ÖNCE türetilmeli.
  // bandList null = henüz yüklenmedi; [] = bu tipte bant yok (kök/ölü uç tip → atanamaz).
  const pbLive = isLiveStandId ? bridgedProject?.projeBeyani : null;
  const awaitingTypeId = pbLive?.awaitingSystemAssignment ? (pbLive.declaredStandTypeId ?? null) : null;
  const bandList = awaitingTypeId != null && bandOptions?.typeId === awaitingTypeId ? bandOptions.list : null;
  const bandPick = bandList ? pickHeightBand(bandList, pbLive?.declaredHeightNumber) : null;
  // #671: "Değiştir" offers only the bands whose range contains the declared height (assign-system refuses the others).
  const bandChoices = bandList ? heightBandChoices(bandList, pbLive?.declaredHeightNumber) : null;
  // WAS (until #671): && Boolean(bandList?.some((b) => String(b.stand_height_id) === String(assignHeightId)));
  const manualBandValid = Boolean(assignHeightId)
    && Boolean(bandChoices?.some((b) => String(b.stand_height_id) === String(assignHeightId)));
  const selectedHeightId = manualBandValid
    ? Number(assignHeightId)
    : (bandPick?.band ? Number(bandPick.band.stand_height_id) : null);
  // Zorunlu belge çözümüne verilecek bant: atama bekliyorsa ADAY bant (önizleme),
  // atanmışsa projenin bandı. Bant yoksa _PSS seviyeleri çözülemiyor.
  const levelHeightId = pbLive?.awaitingSystemAssignment
    ? selectedHeightId
    : (pbLive?.standHeightId ?? bridgedProject?.standHeightId ?? null);
  const levelPending = Boolean(pbLive?.awaitingSystemAssignment) && bandList === null;

  useEffect(() => { document.title = i18n.t("projeler:standOverviewDetail.standDetayiFds"); }, []);

  useEffect(() => {
    if (!isLiveStandId) return;
    let ignore = false;
    getProjeGorselleriCorners().then((list) => { if (!ignore) setLiveCorners(list); }).catch(() => { if (!ignore) setLiveCorners([]); });
    return () => { ignore = true; };
  }, [isLiveStandId]);

// WAS (until #209, the Kroki tab probed the hall plan; StandPlanBolumu probes it itself now):
//   // Kroki yoklaması — iframe'i mount etmeden önce "bu salonun krokisi var mı" diye sorar,
//   // çünkü çapraz kaynak iframe'in içindeki 404 ekranını okuyamıyoruz
//   // (bkz. krokiVectorService.resolveStandPlanDocument). Sekme açılana kadar çalışmaz.
//   const krokiStandFairId = stand?.fuarId ?? null;
//   const krokiStandHallId = stand?.salonId ?? null;
//   useEffect(() => {
//     if (activeTab !== "kroki") return;
//     let ignore = false;
//
//     async function run() {
//       const sonuc = await resolveStandPlanDocument({
//         fairId: krokiStandFairId,
//         hallId: krokiStandHallId,
//       });
//       if (!ignore) setKrokiProbe(sonuc);
//     }
//
//     run();
//     return () => { ignore = true; };
//   }, [activeTab, krokiStandFairId, krokiStandHallId]);

  // #211: the project names a reviewer by user id only; the names come from GET /users/staff (staff only - this is a staff page),
  // once, and only when some file or title decision names a reviewer. An id the list does not know shows as "#id".
  const reviewersWanted = isLiveStandId && needsReviewerNames(bridgedProject);
  useEffect(() => {
    if (!reviewersWanted) return undefined;
    let ignore = false;
    getStaffUsers().then((rows) => { if (!ignore) setStaffNames(staffNameMap(rows)); }).catch(() => {});
    return () => { ignore = true; };
  }, [reviewersWanted]);

  // Revize edilebilir beyan alanları — çalışma anında değişmez, sayfa başına bir kez.
  // Boş dönerse "Beyan Alanı" hedefi modalda kapalı kalır (uydurma key göndermektense
  // seçeneği hiç sunmamak doğru).
  useEffect(() => {
    let ignore = false;
    getRevisableFields({ forceLive: isLiveStandId })
      .then((list) => { if (!ignore) setRevisableFields(list || []); })
      .catch(() => { if (!ignore) setRevisableFields([]); });
    return () => { ignore = true; };
  }, [isLiveStandId]);

  // Proje kaydı henüz yoksa kök stand tiplerini getir (5 satır, ucuz çağrı).
  useEffect(() => {
    if (!isLiveStandId || loading || bridgedProject) return;
    let ignore = false;
    getStandTypes(null, { forceLive: true })
      .then((list) => { if (!ignore) setRootStandTypes(list || []); })
      .catch(() => { if (!ignore) setRootStandTypes([]); });
    return () => { ignore = true; };
  }, [isLiveStandId, loading, bridgedProject]);

  // Dekoratör beyan ettiyse (awaitingSystemAssignment) beyan edilen tipe göre
  // geçerli yükseklik bantlarını getir. Liste assign-system'in kullanacağı tiple
  // AYNI tipten gelmeli (standTypeId göndermiyoruz → backend declaredStandTypeId alır),
  // bant geçerliliği ağaçta miras almıyor.
  useEffect(() => {
    if (awaitingTypeId == null) return undefined;
    let ignore = false;
    getStandHeights(awaitingTypeId, { forceLive: true })
      .then((list) => { if (!ignore) setBandOptions({ typeId: awaitingTypeId, list: list || [] }); })
      .catch(() => { if (!ignore) setBandOptions({ typeId: awaitingTypeId, list: [] }); });
    return () => { ignore = true; };
  }, [awaitingTypeId]);

  // Fuarın zorunlu beyan formları + BU PROJE için doldurulma durumu. Opsiyonel
  // zenginleştirme: tablo/uç yoksa 500 döner ve sayfa yine de çalışmalı.
  // ⚠️ `filled` ancak `completionKnown` true iken anlamlı — bu uç proje bazlı
  //    olduğu için burada her zaman true gelir, ama fuar bazlı listede gelmez.
  useEffect(() => {
    if (!isLiveStandId || !bridgedProject?.id) return undefined;
    let ignore = false;
    getProjectDeclarationForms(bridgedProject.id, { forceLive: true })
      .then((rows) => { if (!ignore) setProjectForms(rows || []); })
      .catch(() => { if (!ignore) setProjectForms([]); });
    return () => { ignore = true; };
    // bridgedProject (id değil): refreshStand sonrası form durumu da tazelensin —
    // yoksa doldurulan zorunlu form düğmeyi kapalı tutmaya devam ederdi.
  }, [isLiveStandId, bridgedProject]);

  // Zorunlu belgeleri 5 seviyeli kaskadın HANGİSİNİN çözdüğü. OPSİYONEL zenginleştirme:
  // patlarsa sayfa aynen çalışmalı (kural sistemi migrasyonları çalışmamış bir ortamda
  // da bu ekran açılabilmeli), o yüzden hata sessizce null'a düşüyor.
  //
  // ⚠️ Burada AYRICA /fuar/{id}/kural/effective çağırmıyoruz: geçerli tavan, kaynağı ve
  //    serbest kW hakkı zaten projeBeyani'nin İÇİNDE geliyor (effectiveHMax /
  //    effectiveHMaxSource / freeKw — teyit: stand 57557, 2026-08-25). Aynı cevabı ikinci
  //    bir turla almak, iki kaynağın ayrışabileceği bir yer yaratırdı. Beyan FORMU
  //    (FirmaProjelerListPage.jsx) o ucu çağırmaya devam ediyor — orada henüz bir
  //    projeBeyani yok ve min/maks m² ile cam/boya sorularına da ihtiyaç var.
  useEffect(() => {
    const pbLocal = bridgedProject?.projeBeyani;
    const fuarId = stand?.fuarId;
    const typeId = resolveTargetStandTypeId(bridgedProject);
    if (!isLiveStandId || !fuarId || !typeId || levelPending) return undefined;
    let ignore = false;

    async function run() {
      try {
        // judgedHeight: kabul edilen, yoksa beyan edilen yükseklik.
        const height = getAcceptedHeight(pbLocal) ?? pbLocal?.declaredHeightNumber ?? null;
        const lvl = await getEffectiveRequiredFiles({
          projectId: bridgedProject?.id ?? null, standId: stand?.standId ?? null,
          standTypeId: typeId, standHeightId: levelHeightId, height, fuarId, forceLive: true,
        });
        // Hangi bantla çözüldüğü etiketleniyor — bant değişip cevap gelene kadar eski
        // önizleme yeni bandın altında görünmesin.
        if (!ignore) setRequiredLevel(lvl ? { ...lvl, standHeightId: levelHeightId } : null);
      } catch { if (!ignore) setRequiredLevel(null); }
    }

    run();
    return () => { ignore = true; };
  }, [isLiveStandId, bridgedProject, stand, levelHeightId, levelPending]);

  // Proje Bilgileri'nde "Proje Türü"/"Kat Bilgisi" için tam ağaç kırıntısı —
  // declaredStandTypeId varsa (dekoratörün asıl seçtiği tip, Sistem Ataması'ndan
  // önce bile geçerli) onu, yoksa projenin kendi standTypeId'sini kullanır. Kat
  // kategorisi (Tek Katlı/Çift Katlı) bu ağaçta ayrı bir alan değil, seviye 2'nin
  // adı — bkz. FE-ProjectController-catalog-guide.md "GET /stand-type-path".
  useEffect(() => {
    if (!isLiveStandId) return;
    const targetTypeId = resolveTargetStandTypeId(bridgedProject);
    if (!targetTypeId) return;
    let ignore = false;
    getStandTypePath(targetTypeId, { forceLive: true })
      .then((path) => { if (!ignore) setStandTypePath(path || []); })
      .catch(() => { if (!ignore) setStandTypePath([]); });
    return () => { ignore = true; };
  }, [isLiveStandId, bridgedProject]);

  function showSuccess(msg) {
    setSuccessMsg(msg);
    setTimeout(() => setSuccessMsg(null), 3000);
  }

  useEffect(() => {
    let ignore = false;

    async function run() {
      setLoading(true);
      setError(null);
      try {
        const detail = await getStandOverviewDetail(standId, { forceLive: isLiveStandId });
        if (ignore) return;
        setStand(detail);
        // Canlı modda bridgedProject zaten standTypeName'i çözülmüş getirir (aşağıya
        // bkz.) — ayrı bir breadcrumb çağrısına gerek yok, sadece mock için.
        if (!isLiveStandId && detail.standTypeId) {
          const path = await getStandTypePath(detail.standTypeId);
          if (!ignore) setStandTypeName(path?.[path.length - 1]?.standTypeName ?? null);
        }
        // Köprü isteğe bağlı bir zenginleştirme — başarısız olursa ana sayfa yine de
        // render edilmeli, bu yüzden ayrı try/catch'te (dış catch'i tetiklemesin).
        if (detail.standId) {
          try {
            const bridged = await getProjectByStandId(detail.standId, { forceLive: isLiveStandId });
            if (!ignore) setBridgedProject(bridged);
          } catch {
            if (!ignore) setBridgedProject(null);
          }
        }
      } catch (e) {
        if (!ignore) setError(e.message);
      } finally {
        if (!ignore) setLoading(false);
      }
    }

    run();
    return () => { ignore = true; };
  }, [standId, isLiveStandId]);

  // #217: the taahhutnameler are read when the Proje Durumu tab of a live project is open, and again after every write that touches them.
  useEffect(() => {
    if (activeTab !== "commitments" || !isLiveStandId || !bridgedProject?.id) return undefined;
    let ignore = false;
    async function run() {
      try {
        const d = await getTaahhutnameler(bridgedProject.id);
        if (!ignore) {
          setTaahhut(d);
          setTaahhutHata(null);
        }
      } catch (e) {
        if (!ignore) setTaahhutHata(e.message);
      }
    }
    run();
    return () => { ignore = true; };
  }, [activeTab, isLiveStandId, bridgedProject?.id, taahhutYenile]);

  // Onay/seçim aksiyonları sonrası sekmeyi terk etmeden sessizce güncel veriyi çeker
  // — sayfa geneli loading spinner'ını tetiklemez.
  async function refreshStand() {
    const detail = await getStandOverviewDetail(standId, { forceLive: isLiveStandId });
    setStand(detail);
    if (detail.standId) {
      try {
        setBridgedProject(await getProjectByStandId(detail.standId, { forceLive: isLiveStandId }));
      } catch {
        setBridgedProject(null);
      }
    }
  }

  // ─── Proje Kaydı Oluştur (adım 1) ───────────────────────────────────────────
  // 2026-08-24: adım 1 artık YÜKSEKLİK TAŞIMIYOR. Akış yön değiştirdi — eskiden staff
  // organizatörle mutabık kalınan yüksekliği önce girerdi ve dekoratör başka bir şey
  // beyan ederse proje kilitlenirdi (HEIGHT_MISMATCH). Artık kimse önce bir yükseklik
  // girmiyor: dekoratör beyan eder, beyan fuar kural setine karşı yargılanır, staff
  // adım 3'te KABUL eder ve projectHeightNumber o zaman yazılır.
  async function handleCreateShell() {
    if (!shellStandTypeId) return;
    setCreatingShell(true);
    setError(null);
    try {
      await createProject({
        standId: stand.standId, firmaId: stand.firmaId, fuarId: stand.fuarId,
        dekoratorFirmaId: stand.dekoratorFirmaId,
        standTypeId: Number(shellStandTypeId),
      }, { forceLive: true });
      setShellStandTypeId("");
      await refreshStand();
      showSuccess(tx("standOverviewDetail.projeKaydiOlusturulduDekoratorArtik"));
    } catch (e) {
      setError(e.message);
    } finally {
      setCreatingShell(false);
    }
  }

  // ─── Proje Özel İzni kararı ──────────────────────────────────────────────────
  // Denetmen zaten projenin başında; tepsiye gitmeden burada da karar verebilsin.
  // ⚠️ Backend YETKİ KONTROLÜ YAPMIYOR (guide §8.2) — bu düğmeler yalnızca denetmen
  //    rollerine açık bu sayfada var, katılımcı ekranlarında YOK.
  // ⚠️ Reddederken gerekçe ZORUNLU: katılımcının nedenini okuyacağı tek yer orası.
  async function handlePermitDecision() {
    const izin = bridgedProject?.projeBeyani?.ozelIzin;
    if (!izin || !permitDecision) return;
    if (!permitDecision.onay && !permitNote.trim()) return;
    setPermitBusy(true);
    setError(null);
    try {
      await decideOzelIzin(izin.id, permitDecision.onay, permitNote.trim() || null, { forceLive: true });
      setPermitDecision(null);
      setPermitNote("");
      await refreshStand();
      showSuccess(permitDecision.onay
        ? tx("standOverviewDetail.ozelIzinOnaylandiIhlallerListede")
        : tx("standOverviewDetail.ozelIzinReddedildiProjeKilitli"));
    } catch (e) {
      setError(e.message);
    } finally {
      setPermitBusy(false);
    }
  }

  // ─── Sistem Ataması (adım 3) ─────────────────────────────────────────────────
  async function handleAssignSystem() {
    if (!bridgedProject || !selectedHeightId) return;
    setAssigningSystem(true);
    setError(null);
    try {
      await assignProjectSystem(bridgedProject.id, selectedHeightId, { forceLive: true });
      setAssignHeightId("");
      setBandManual(false);
      await refreshStand();
      showSuccess(tx("standOverviewDetail.sistemAtamasiYapildiZorunluBelge"));
    } catch (e) {
      setError(e.message);
    } finally {
      setAssigningSystem(false);
    }
  }

  // ─── Kilit Kaldırma (override) ───────────────────────────────────────────────
  async function handleOverrideLock() {
    if (!bridgedProject) return;
    setOverridingLock(true);
    setError(null);
    try {
      await overrideHeightLock(bridgedProject.id, overrideNote, { forceLive: true });
      setOverrideNote("");
      await refreshStand();
      showSuccess(tx("standOverviewDetail.kilitKaldirildi"));
    } catch (e) {
      setError(e.message);
    } finally {
      setOverridingLock(false);
    }
  }

  async function handleFileApproval(fileId, status) {
    setActionLoading(true);
    try {
      const file = uploadedFiles.find((f) => f.id === fileId);
      await setUploadedFileApproval(standId, fileId, status, {
        forceLive: isLiveStandId, projectId: bridgedProject?.id, standFileId: file?.standFileId,
      });
      await refreshStand();
    } finally {
      setActionLoading(false);
    }
  }

  // #213: ONE file reviewed on its own (PUT /projects/{id}/files/{fileId}/approval): 1 approves it, 2 rejects it with the reason
  // the company will see. The title's decision (handleFileApproval) is a separate call and stays the group's.
  async function handleFileReview(fileId, status, rejectReason) {
    setActionLoading(true);
    setError(null);
    try {
      await setUploadedFileReview(standId, fileId, status, rejectReason, {
        forceLive: isLiveStandId, projectId: bridgedProject?.id,
      });
      await refreshStand();
      setTaahhutYenile((n) => n + 1);   // #217: a rejected source or signed copy changes the taahhutname's state
    } catch (e) {
      const d = e.response?.data;
      setError(typeof d === "string" && d ? d : (d?.message ?? e.message));
    } finally {
      setActionLoading(false);
    }
  }

  // #217 / #505: the electrician's signature (staff only; the backend refuses a company). Each call answers the refreshed taahhutnameler,
  // so there is no second read; the error goes back to the panel (it shows the backend text).
  async function handleElektrikci(yaz) {
    setActionLoading(true);
    try {
      setTaahhut(await yaz());
      await refreshStand();
    } finally {
      setActionLoading(false);
    }
  }
  const handleElektrikciKaydet = (govde) => handleElektrikci(() => recordElektrikciImzasi(bridgedProject.id, govde));
  const handleElektrikciFoto = (foto) => handleElektrikci(() => setElektrikciFotografi(bridgedProject.id, foto));
  const handleElektrikciKaldir = (not) => handleElektrikci(() => removeElektrikciImzasi(bridgedProject.id, not));

  async function handleChooseCommitment(commitmentKey, fileId) {
    setActionLoading(true);
    try {
      await chooseFileForCommitment(standId, commitmentKey, fileId, {
        forceLive: isLiveStandId, projectId: bridgedProject?.id,
      });
      await refreshStand();
      setTaahhutYenile((n) => n + 1);   // #217
    } finally {
      setActionLoading(false);
    }
  }

  // ─── Revizyon ─────────────────────────────────────────────────────────────
  function closeRevisionModal() {
    setRevisionModal(false);
    setRevisionTargetKind("FREEFORM");
    setRevisionStandFileId("");
    setRevisionFieldKey("");
    setRevisionText("");
    setRevisionScreenshot(null);
    if (screenshotInputRef.current) screenshotInputRef.current.value = "";
  }

  async function handleCreateRevision() {
    if (!bridgedProject || !revisionText.trim()) return;
    if (revisionTargetKind === "DOCUMENT" && !revisionStandFileId) return;
    if (revisionTargetKind === "SPEC_FIELD" && !revisionFieldKey) return;
    setActionLoading(true);
    try {
      // Bir revizyon ya belgeyi ya beyan alanını hedefler, ikisini birden değil —
      // backend `fieldKey` + `type=VISUAL` kombinasyonunu 400'le reddediyor.
      const created = await createRevision(
        bridgedProject.id,
        revisionTargetKind === "DOCUMENT" ? "visual" : "structural",
        revisionText.trim(),
        {
          standFileId: revisionTargetKind === "DOCUMENT" ? Number(revisionStandFileId) : null,
          fieldKey: revisionTargetKind === "SPEC_FIELD" ? revisionFieldKey : null,
          screenshotFile: revisionScreenshot,
          forceLive: isLiveStandId,
        },
      );
      closeRevisionModal();
      // Yeni konuşma kendi sayfasında devam eder — burada refreshStand'a gerek yok.
      navigate(`/Management/Projects/Stands/${standId}/revisions/${created._id}`);
    } catch (e) {
      setError(e.message);
    } finally {
      setActionLoading(false);
    }
  }

  async function handleDeleteRevision() {
    if (!bridgedProject || !deleteRevisionId) return;
    setActionLoading(true);
    try {
      await deleteRevision(bridgedProject.id, deleteRevisionId, { forceLive: isLiveStandId });
      setDeleteRevisionId(null);
      await refreshStand();
      showSuccess(tx("standOverviewDetail.revizyonSilindi"));
    } catch (e) {
      setError(e.message);
    } finally {
      setActionLoading(false);
    }
  }

  if (loading) {
    return (
      <div className="page-content">
        <Container fluid className="text-center py-5"><Spinner color="primary" /></Container>
      </div>
    );
  }

  if (error && !stand) {
    return (
      <div className="page-content">
        <Container fluid>
          <Alert color="danger">{error}</Alert>
          <Button color="secondary" outline size="sm" onClick={() => navigate(backTo)}>
            <ArrowLeft size={14} className="me-1" />{" "}{tx("standOverviewDetail.listeyeDon")}
          </Button>
        </Container>
      </div>
    );
  }

  if (!stand) return null;

  // Gerçek backend'de bir standın katılımcı firması olması, inşaat projesi olduğu
  // anlamına gelmez (bkz. GET /projects/by-stand 404 durumu) — bu yüzden "proje var mı"
  // artık bridgedProject'e bakıyor, stand.firmaId'ye değil. Mock modda da geçerli:
  // standOverviewService mock'unda proje bilgisi girilmiş her stand zaten bridge'siz
  // kendi içinde requiredCount>0 taşır, aşağıdaki requiredCount/approvedCount hâlâ
  // stand'e düşer (fallback).
  const hasProject = Boolean(bridgedProject);
  // Banner'daki firma adı gösterimi projeden bağımsız — gerçek backend'de bir standın
  // katılımcı firması olup henüz inşaat projesi olmaması gayet normal bir ara durum.
  const hasFirma = Boolean(stand.firmaId);
  // Salon kutusundaki büyük satır. Salon adı genelde sadece bir sayı ("1", "11"),
  // ama mock/özel salonlarda serbest metin olabiliyor ("Mock Salon A (mock)") —
  // o zaman kutu şişip banner'daki firma adının üstüne biniyordu. Sayı varsa sayıyı,
  // yoksa adı KÜÇÜK punto + kırpılmış olarak basıyoruz (tam adı title'da).
  const salonDigits = stand.salonName?.match(/\d+/)?.[0] ?? null;
  const salonNumber = salonDigits ?? stand.salonName ?? "—";

  // "Kroki" sekmesi: gömülü fdsvector stand planı fuar + SALON id'si ister ve o çift
  // fdsvector'de etkinleştirilmemişse 404 döner. iframe çapraz kaynak olduğu için
  // içindeki hata ekranını okuyamayız — bu yüzden mount ETMEDEN ÖNCE aynı soruyu
  // ana sayfadan soruyoruz (krokiProbe). Sonuç:
  //   ok           → standın kendi salon krokisi gömülür
  //   missing-id   → standın salon id'si yok (mock kayıtlar, bazı canlı standlar)
  //   not-mapped   → salon bu fuarda etkin değil, yani bu salonun krokisi çizilmemiş
  // Son iki durumda kullanıcı boş kutu görmesin diye tanıtım dokümanına düşülür ve
  // bunun bu standa ait olmadığı açıkça yazılır.
  // WAS (until #209, the Kroki tab):
  // const krokiKendiPlani = krokiProbe?.ok === true;
  // const krokiFairId = krokiKendiPlani ? stand.fuarId : ORNEK_STAND_PLAN.fairId;
  // const krokiHallId = krokiKendiPlani ? stand.salonId : ORNEK_STAND_PLAN.hallId;

  // Proje/belge alanları: mock modda doğrudan stand üzerinde, canlı modda standId
  // köprüsüyle bulunan bridgedProject üzerinde (standOverviewService.js artık bunları
  // döndürmüyor — bkz. o dosyadaki getStandOverviewDetail yorumu). İkisi birbirini
  // dışlar (bir stand aynı anda hem mock hem canlı olamaz), bu yüzden basit ?? yeterli.
  const requiredCount = bridgedProject?.requiredCount ?? stand.requiredCount ?? 0;
  const approvedCount = bridgedProject?.approvedCount ?? stand.approvedCount ?? 0;
  const uploadedFiles = bridgedProject?.uploadedFiles ?? stand.uploadedFiles ?? [];
  const fileApprovalsSource = bridgedProject?.fileApprovals ?? stand.fileApprovals ?? [];
  // Taahhütnameler: roster gerçek üretim zincirini taşıyorsa ONU kullan. Yerel
  // synthesizeCommitments standFileId 5'in alt dosyalarını tarayıp bir durum
  // UYDURUYOR — kaynak belgeler 2026-08-29'dan beri 5'te değil (İSG←3D Köşe/2,
  // Elektrik←Kuşbakışı/2, Statik←Statik Hesap/7), bu yüzden canlıda "Belge Yok"
  // diyordu, roster aynı taahhütname için "Kaynak yüklendi" derken. Sentez sadece
  // mock kayıtlar ve roster'a ulaşılamayan durumlar için fallback olarak duruyor.
  const rosterCommitments = Array.isArray(stand.commitments) && stand.commitments.length > 0
    && stand.commitments.some((c) => c.state)
    ? stand.commitments
    : null;
  const commitments = rosterCommitments
    ?? (bridgedProject ? synthesizeCommitments(uploadedFiles, fileApprovalsSource) : []);
  const projectHeightNumber = stand.projectHeightNumber ?? bridgedProject?.projectHeightNumber ?? null;
  // standTypePath sadece hedef tipiyle (declaredStandTypeId varsa o, yoksa
  // projenin kendi standTypeId'si) eşleşiyorsa kullanılır — bridgedProject
  // değişip yeni fetch dönene kadar bir önceki standın kırıntısı gösterilmez.
  const standTypePathTargetId = isLiveStandId ? resolveTargetStandTypeId(bridgedProject) : null;
  const effectiveStandTypePath = standTypePath[standTypePath.length - 1]?.standTypeId === standTypePathTargetId
    ? standTypePath
    : [];
  const katKategorisiCrumb = effectiveStandTypePath.find((c) => c.level === 2);
  const leafTypeCrumb = effectiveStandTypePath[effectiveStandTypePath.length - 1];
  const standTypeNameDisplay = standTypeName ?? leafTypeCrumb?.standTypeName ?? bridgedProject?.standTypeName ?? null;
  const katBilgisiDisplay = stripParallelTreeMarker(katKategorisiCrumb?.standTypeName) ?? stand.floorInfo ?? null;
  // Proje Bilgileri'nde stand tipinin HER seviyesi ayrı bir kutucuk — kök (Paket/
  // Özel/Pavilyon), kat kategorisi, materyal/alt tip, hepsi birden görünür, biri
  // diğerinin yerine geçmez. Sadece canlı köprüde tam ağaç var (effectiveStandTypePath);
  // yoksa (mock, veya henüz çözülmediyse) eski tek-kutucuk davranışına düşer.
  // ⚠️ stripParallelTreeMarker: katalog uçları adı HAM veriyor ("Paket Stand (n)"),
  // roster ise işareti atılmış veriyor ("Paket Stand") — aynı stand iki sayfada iki
  // farklı ad taşıyordu. Hangi ağaçtan geldiğini id söyler, ad değil.
  const typeTiles = effectiveStandTypePath.length > 0
    ? effectiveStandTypePath.map((crumb) => ({
        icon: typeLevelIcon(crumb.level),
        label: `${typeLevelLabel(crumb.level)}: ${stripParallelTreeMarker(crumb.standTypeName)}`,
      }))
    : [{ icon: Layers3, label: tx("standOverviewDetail.projeTuru2", { v: stripParallelTreeMarker(standTypeNameDisplay) ?? "—" }) }];

  // ─── İnşa İzni / İş İzni — 2026-09-04: ARTIK TÜRETİLMİYOR ────────────────────
  // Eskiden burada `requiredCount > 0 && approvedCount === requiredCount` vardı ve
  // sonucu "İnşaat İzni Var/Yok" diye basıyordu. Bu, canlıda YANLIŞ BİLGİYDİ: aynı
  // stand listede "İzin Bekliyor" (statusId 2) derken detay "İnşaat İzni Yok" diyordu.
  // İzin bir stand_status araması (5 satır, staff genişletebilir), belge sayacı değil
  // — cevap `constructionPermit.statusId`, renk `constructionPermit.badge`
  // (bkz. missing-pills-guide.md §5). İş İzni de aynı şekilde kendi rollup'ından gelir
  // (§6: jobApproved/jobTotal İŞ İZNİ SAYACI DEĞİL).
  // Roster satırı bulunamazsa (mock kayıtlar, ya da arama standı bulamazsa) ikisi de
  // eski boolean alanlara düşer — bkz. StandPills.permitBadge/workPermitBadge.
  const insaIzniBadge = permitBadge(stand);
  const isIzniBadge = workPermitBadge(stand);
  // Zorunlu belge sayacı hâlâ anlamlı bir bilgi — sadece artık "izin" DİYE
  // sunulmuyor; kendi cümlesiyle (kaç zorunlu belgeden kaçı onaylı) gösteriliyor.
  const tumBelgelerOnayli = hasProject && requiredCount > 0 && approvedCount === requiredCount;

  // Anlaşma durumu / finans onayı / serin proje köprüden (by-stand), borç ve izinler
  // roster'dan gelir — StandExtraInfoIndicator ikisini birden bekliyor, bu yüzden
  // liste satırıyla aynı şekle sahip tek bir nesnede birleştiriliyor.
  const standWithProjectFlags = {
    ...stand,
    dealStatus: stand.dealStatus ?? bridgedProject?.dealStatus,
    financeApproval: stand.financeApproval ?? bridgedProject?.financeApproval,
  };
  const standIssue = hasIssue(standWithProjectFlags);
  const serinProje = stand.serinProje ?? bridgedProject?.serinProje ?? false;

  const fileApprovalsMap = {};
  fileApprovalsSource.forEach((fa) => { fileApprovalsMap[fa.standFileId] = fa.status; });

  // Proje Görselleri: mock'ta standFileId 5 + sabit 4 köşe, canlı modda standFileId 2 +
  // gerçek file_type köşeleri (isimle çözülür, bkz. getProjeGorselleriCorners).
  const projeGorselleriStandFileId = isLiveStandId ? 2 : 5;
  const projeGorselleriAngles = isLiveStandId
    ? (liveCorners || []).map((c, i) => ({
        key: CORNER_POSITIONS[i]?.key ?? c.name,
        subStandFileId: c.fileTypeId,
        label: c.name,
        style: CORNER_POSITIONS[i]?.style ?? {},
      }))
    : ANGLES;
  const projeGorselleriAngleLabels = Object.fromEntries(projeGorselleriAngles.map((a) => [a.subStandFileId, a.label]));

  // Sadece gerçek konuşma nesnelerini say — bridgedProject.revisions, Semra'nın
  // ProjectDetailPage.jsx'indeki ESKİ addRevision ile eklenmiş düz notları da
  // (messages[] yok) içerebilir; bkz. projectService.js'teki addRevision notu.
  const revisions = (bridgedProject?.revisions || []).filter(r => Array.isArray(r.messages));

  // Bitmemiş BELGE revizyonu olan belge tipleri → Proje Evrakları sekmesinde ‼ rozeti.
  // ⚠️ `status === "open"` DEĞİL: dekoratör dosyayı yükleyince revizyon ANSWERED'a
  // geçiyor ama hâlâ bizim kararımızı bekliyor — rozetin kaybolmaması gerekir.
  const openVisualByFile = {};
  revisions.forEach(r => {
    if (r.targetKind === "DOCUMENT" && isRevisionUnfinished(r) && r.standFileId != null) {
      const existing = openVisualByFile[r.standFileId];
      if (!existing || new Date(r.updatedAt) > new Date(existing.updatedAt)) openVisualByFile[r.standFileId] = r;
    }
  });

  // project.inRevision / project.pendingProposal backend'de denormalize tutulur; burada
  // yüklü revizyonlardan sayarak aynı iki soruya sayı da veriliyor (rozet metni için).
  const unfinishedRevisionCount = revisions.filter(isRevisionUnfinished).length;
  const pendingProposalCount = revisions.filter((r) => r.status === "answered").length;

  function goToRevision(revisionId) {
    navigate(`/Management/Projects/Stands/${standId}/revisions/${revisionId}`);
  }

  // Proje Beyanı durumu — staff'ın adım 1 (kayıt aç)/3 (sistem ata)/override
  // aksiyonlarının hangisini göstereceğine karar verir. Sadece canlı köprüde
  // anlamlı; mock projelerde (_mockProjects) projeBeyani alanı hiç yok.
  const pb = isLiveStandId ? bridgedProject?.projeBeyani : null;
  // Aday bantla çözülen zorunlu belge önizlemesi — sadece cevap GERÇEKTEN bu bant için
  // geldiyse. assign-system mevcut onayları artık gerekmeyen başlıklarda DÜŞÜRÜYOR
  // (beyani-revisions guide Trap 7), o yüzden kaybolacak onaylar kabulden ÖNCE gösteriliyor.
  const bandPreview = pb?.awaitingSystemAssignment && selectedHeightId != null
    && requiredLevel?.standHeightId === selectedHeightId ? requiredLevel : null;
  const previewFileIds = new Set((bandPreview?.files ?? []).map((f) => Number(f.stand_file_id)));
  const droppedApprovals = bandPreview
    ? (bridgedProject?.fileApprovals ?? []).filter((fa) =>
      Number(fa.status) === 1 && !previewFileIds.has(Number(fa.standFileId)))
    : [];
  const fileShortName = (standFileId) => {
    const rf = (bridgedProject?.requiredFiles ?? []).find((f) => Number(f.stand_file_id) === Number(standFileId));
    return rf?.stand_file_shortname ?? rf?.stand_file_name ?? `#${standFileId}`;
  };
  const fmtBandRange = (b) => `${b.stand_height_start ?? "?"}–${b.stand_height_end ?? "?"} m`;
  // assign-system 2026-08-28 itibariyle iki yeni sebeple 400 doner ve ikisi de DUZ
  // METIN: bekleyen bir Proje Ozel Izni, ve doldurulmamis zorunlu beyan formu.
  // Ikisini de kendimiz okuyup dugmeyi onden kapatiyoruz — kullanici duz metin bir
  // 400'den ogrenmesin. Backend once izni soyler, ama proje ikisine birden takilabilir.
  const assignBlocked = Boolean(pb?.ozelIzinBekliyor) || blockingDeclarationForms(projectForms).length > 0;

  // #210: what only the gray pill row showed, as tiles of Proje Bilgileri - the stand category, the project type / structure,
  // the electricity (kW) and Yerli / Yabancı. The stand type, the floor, the height and the area were tiles already.
  const kategoriLabel = resolvePillLabel(stand.standCategory, STAND_CATEGORY_LABELS);
  const projeTipiLabel = resolvePillLabel(stand.projectType, PROJECT_TYPE_LABELS);
  const yapiLabel = resolvePillLabel(stand.projectStructure, PROJECT_STRUCTURE_LABELS);
  const ekBilgiTiles = [
    ...(stand.firmaNation != null ? [{ icon: stand.firmaNation === 1 ? Flag : Globe, label: tx("standOverviewDetail.katilimci", { v: stand.firmaNation === 1 ? tx("standOverviewDetail.yerli") : tx("standOverviewDetail.yabanci") }) }] : []),
    ...(kategoriLabel ? [{ icon: Package, label: tx("standOverviewDetail.standKategorisi", { v: kategoriLabel }) }] : []),
    ...(projeTipiLabel ? [{ icon: Layers, label: tx("standOverviewDetail.projeTipi", { v: projeTipiLabel }) }] : []),
    ...(yapiLabel ? [{ icon: Puzzle, label: tx("standOverviewDetail.projeYapisi", { v: yapiLabel }) }] : []),
    ...(stand.kw != null ? [{ icon: Zap, label: tx("standOverviewDetail.elektrikKw", { v: stand.kw }) }] : []),
  ];

  // #210: "Proje Bilgilerini Düzenle" - a live project only; while the exhibitor's declaration still waits for "Sistemi Onayla" the
  // type and the band are set THERE (the system-assignment card), so the button stays off with the reason.
  const duzenlenebilir = isLiveStandId && hasProject && !pb?.awaitingSystemAssignment;
  const editButton = isLiveStandId && hasProject ? (
    <Button
      size="sm" color="primary" outline disabled={!duzenlenebilir} onClick={() => setProjeDuzenle(true)}
      title={duzenlenebilir ? undefined : tx("projeBilgiDuzenle.sistemAtamasiBekliyor")}
      data-testid="proje-bilgi-duzenle"
    >
      <Pencil size={13} className="me-1" />{tx("projeBilgiDuzenle.dugme")}
    </Button>
  ) : null;

  // #211: the tracking list under a document card.
  // #213: `withRevisions` false on the Proje Evrakları tab, whose cards carry the red revision badge already.
  const takip = (standFileId, entries, withRevisions = true) => (
    <DosyaTakip
      entries={entries}
      names={staffNames}
      onPreview={setPreviewFile}
      decision={titleDecision(fileApprovalsSource, standFileId)}
      openRevisions={withRevisions ? openDocumentRevisions(revisions, standFileId, isRevisionUnfinished) : []}
      onOpenRevision={(r) => goToRevision(r._id)}
    />
  );

  // #209: the stand's own plan and its place in the hall. Live stands only (a mock stand id names no real stand); a stand with no
  // project record has the section too (its place in the hall does not depend on a project).
  const planBolumu = isLiveStandId ? (
    <StandPlanBolumu s={{ standId: stand.standId, standName: stand.standName, salonId: stand.salonId, salonName: stand.salonName, fuarId: stand.fuarId }} />
  ) : null;

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title={tx("standOverviewDetail.stand", { standName: stand.standName })} pageTitle={tx("standOverviewDetail.projeler")} />

        {error && <Alert color="danger">{error}</Alert>}
        {successMsg && <Alert color="success">{successMsg}</Alert>}

        <Button color="secondary" outline size="sm" className="mb-3" onClick={() => navigate(backTo)}>
          <ArrowLeft size={14} className="me-1" />{" "}{tx("standOverviewDetail.listeyeDon")}
        </Button>

        {/* ─── Banner ───
            Kenarlık Stand Listesi satırıyla AYNI sinyali taşır (hasIssue): dekoratör
            atanmamış / borç var / izin bekliyor-verilmedi / iş izni reddedilmiş ise
            kırmızı. Proje kaydı olmayan standlar bu hesaba dahil değil. */}
        <Card className={`mb-4 overflow-hidden border ${hasFirma ? (standIssue ? "border-danger" : "border-success") : ""}`}>
          <div
            style={{
              backgroundImage: `linear-gradient(180deg, rgba(13,50,54,.55), rgba(13,50,54,.8)), url(${profileBg})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <div className="p-4">
              <div className="d-flex align-items-center gap-3 flex-wrap">
                <div
                  className="bg-white rounded-3 text-center px-3 py-2 shadow-sm flex-shrink-0"
                  style={{ minWidth: 72, maxWidth: 140 }}
                  title={stand.salonName || undefined}
                >
                  <div
                    className={`fw-bold text-dark lh-1 text-truncate ${salonDigits ? "fs-5" : "small"}`}
                  >
                    {salonNumber}
                  </div>
                  {/* standCode = stand_name'in ilk noktadan sonraki parçası ("11.11AF43"
                      → "11AF43"), roster'ın parse'ı. Yoksa tam ada düşülür. §7/§8:
                      standNo diye bir alan YOK ve gelmeyecek. */}
                  <div className="fw-semibold small text-info lh-1 mt-1">{stand.standCode || stand.standName}</div>
                </div>
                <div>
                  {/* Kalın ad = firmaShortName (standın kısa görünen adı), Stand
                      Listesi satırıyla aynı. Tüzel unvan ayrı bir alan, farklıysa
                      altında ince yazıyla duruyor — detay sayfası ikisini de göstermeli. */}
                  <h4 className="text-white mb-0">
                    {hasFirma ? (stand.firmaShortName || stand.firmaName) : stand.standName}
                  </h4>
                  {hasFirma && stand.firmaShortName && stand.firmaShortName !== stand.firmaName && (
                    <div className="text-white-50" style={{ fontSize: 12 }}>{stand.firmaName}</div>
                  )}
                  {hasFirma && (
                    stand.dekoratorFirmaName
                      ? <div className="text-white-50 small">{stand.dekoratorFirmaName}</div>
                      : <Badge color="danger" className="mt-1">{tx("standOverviewDetail.dekoratorTanimlanmamis")}</Badge>
                  )}
                  {/* ─── Durum rozetleri ─── Stand Listesi'nin "i" göstergesindeki aynı
                      beş bilgi; detayda ilk üçü doğrudan görünür (denetçinin bu sayfada
                      asıl aradığı şeyler), anlaşma/finans hover'da kalır. */}
                  {hasFirma && (
                    <div className="d-flex flex-wrap align-items-center gap-1 mt-2">
                      <Badge color={insaIzniBadge.color} className="d-inline-flex align-items-center gap-1">
                        <ShieldCheck size={11} />{tx("standOverviewDetail.insaIzni", { label: insaIzniBadge.label })}
                      </Badge>
                      <Badge color={isIzniBadge.color} className="d-inline-flex align-items-center gap-1">
                        <HardHat size={11} />{tx("standOverviewDetail.isIzni", { label: isIzniBadge.label })}
                      </Badge>
                      <Badge
                        color={stand.hasDebt ? "danger" : "success"}
                        className="d-inline-flex align-items-center gap-1"
                        title={stand.hasDebt ? tx("standOverviewDetail.borcNedeniyleInsaatIzniVerilemez") : undefined}
                      >
                        <Coins size={11} />{tx("standOverviewDetail.borc")}{" "}{stand.hasDebt ? tx("standOverviewDetail.var") : tx("standOverviewDetail.yok")}
                      </Badge>
                      {serinProje && (
                        <Badge color="info" className="d-inline-flex align-items-center gap-1">
                          <Snowflake size={11} />{tx("standOverviewDetail.serinProje")}
                        </Badge>
                      )}
                      <span className="bg-white rounded-circle d-inline-flex">
                        <StandExtraInfoIndicator s={standWithProjectFlags} domId="stand-detay-extra" />
                      </span>
                    </div>
                  )}
                  {/* İKİ AYRI rozet, tek bir tanesi değil (bkz. guide "Both flags can
                      be true at once"): "Revizyonda" bir bulgu olduğunu, "Karar
                      Bekliyor" ise dekoratörün bir şey istediğini ve hamlenin BİZDE
                      olduğunu söyler. Tek rozete katlamak bir değişiklik talebini
                      dekoratör aleyhine bir bulgu gibi gösterirdi. */}
                  {hasProject && unfinishedRevisionCount > 0 && (
                    <Badge color="danger" className="mt-1 ms-1">
                      {tx("standOverviewDetail.revizyonda", { unfinishedRevisionCount })}
                    </Badge>
                  )}
                  {hasProject && pendingProposalCount > 0 && (
                    <Badge color="warning" className="mt-1 ms-1">
                      {tx("standOverviewDetail.kararBekliyor", { pendingProposalCount })}
                    </Badge>
                  )}
                </div>
              </div>
            </div>
            <Nav pills className="px-4 gap-2 border-0" style={{ position: "relative" }}>
              {TABS.map((t) => (
                <NavItem key={t.key}>
                  <NavLink
                    active={activeTab === t.key}
                    className={activeTab === t.key ? "bg-danger text-white" : "bg-white text-dark"}
                    style={{ cursor: "pointer", borderRadius: "6px 6px 0 0" }}
                    onClick={() => setActiveTab(t.key)}
                  >
                    {t.label}
                  </NavLink>
                </NavItem>
              ))}
            </Nav>
          </div>
        </Card>

        {/* ─── Proje Kaydı Oluştur (staff, Proje Beyanı adım 1) ───
            Sadece canlı köprüde: kök stand tipi + söz verilen yükseklik. Mock modda
            (veya proje zaten varsa) devreye girmez, bkz. dosya başı yorumu. */}
        {!hasProject && isLiveStandId && (
          <Card className="mb-3 border border-warning">
            <CardBody>
              <div className="d-flex align-items-center gap-2 mb-2">
                <Layers3 size={16} className="text-warning" />
                <span className="fw-semibold">{tx("standOverviewDetail.projeKaydiOlustur")}</span>
              </div>
              <div className="text-muted small mb-3">
                {tx("standOverviewDetail.buStandinInsaatProjesiHenuz")}
                <span className="fw-semibold">{" "}{tx("standOverviewDetail.buradaYukseklikGirilmez")}</span>{tx("standOverviewDetail.yukseklikDekoratorunBeyanindanGelirSiz")}
              </div>
              <Row className="g-3 align-items-end">
                <Col md={9}>
                  <Label size="sm" className="d-block">{tx("standOverviewDetail.standTuru")}</Label>
                  <StandTypeRows
                    options={rootStandTypes}
                    renderOption={(t, faded) => {
                      const selected = Number(shellStandTypeId) === t.stand_type_id;
                      return (
                        <Button
                          key={t.stand_type_id} type="button" size="sm" color="warning"
                          outline={!selected}
                          className={faded && !selected ? "opacity-50" : undefined}
                          onClick={() => setShellStandTypeId(t.stand_type_id)}
                        >
                          {t.stand_type_name}
                        </Button>
                      );
                    }}
                  />
                  {rootStandTypes.length === 0 && <span className="text-muted small">{tx("common:yukleniyor")}</span>}
                </Col>
                <Col md={3}>
                  <Button
                    color="warning" className="w-100"
                    disabled={creatingShell || !shellStandTypeId}
                    onClick={handleCreateShell}
                  >
                    {creatingShell ? <Spinner size="sm" /> : tx("standOverviewDetail.projeKaydiAc")}
                  </Button>
                </Col>
              </Row>
            </CardBody>
          </Card>
        )}
        {!hasProject && !isLiveStandId && (
          <Alert color="secondary">{tx("standOverviewDetail.buStandHenuzBirInsaat")}</Alert>
        )}

        {/* ─── Proje Beyanı durumu (staff, adım 3 / kilit) ─── */}
        {hasProject && pb?.locked && (
          <Card className="mb-3 border border-danger">
            <CardBody>
              <div className="d-flex align-items-center gap-2 mb-2">
                <Lock size={16} className="text-danger" />
                <span className="fw-semibold">{tx("standOverviewDetail.beyanFuarKurallarinaUymuyorKilitli")}</span>
              </div>
              {/* 2026-08-24: kilidin tek sebebi artık "söz verilen ≠ beyan edilen"
                  (HEIGHT_MISMATCH) DEĞİL — o kural emekliye ayrıldı. Kilit fuar kural
                  setinden geliyor ve HER OKUMADA yeniden türetiliyor: organizatör bir
                  tavanı beyan KABUL EDİLDİKTEN SONRA düşürürse burada kendiliğinden
                  belirir. lockReason yalnızca ilk ihlalin özeti — asıl cevap violations[],
                  o yüzden listenin TAMAMI basılıyor (bkz. guide Trap 3). */}
              <KuralIhlalListesi violations={pb.violations} title={tx("standOverviewDetail.kilideSebepOlanKuralIhlalleri")} />
              {(!pb.violations || pb.violations.length === 0) && (
                <div className="text-muted small mb-3">
                  {tx("standOverviewDetail.kilitSebebi")}{" "}{pb.lockReason ?? tx("standOverviewDetail.bilinmiyor")}{tx("standOverviewDetail.beyan")}{" "}{pb.declaredHeightNumber ?? "—"} m
                  ({stripParallelTreeMarker(pb.declaredStandTypeName) ?? "—"}).
                </div>
              )}
              <div className="text-muted small mb-3">
                {tx("standOverviewDetail.organizatorleGorusulduyseKilidiKaldirabilirsiniz")}
              </div>
              <Row className="g-2 align-items-end">
                <Col md={8}>
                  <Input
                    type="text" bsSize="sm" placeholder={tx("standOverviewDetail.notOpsiyonel")}
                    value={overrideNote} onChange={(e) => setOverrideNote(e.target.value)}
                  />
                </Col>
                <Col md={4}>
                  <Button
                    color="danger" outline size="sm" className="w-100"
                    disabled={overridingLock} onClick={handleOverrideLock}
                  >
                    {overridingLock ? <Spinner size="sm" /> : <><Unlock size={13} className="me-1" />{tx("standOverviewDetail.kilidiKaldir")}</>}
                  </Button>
                </Col>
              </Row>
            </CardBody>
          </Card>
        )}
        {/* ─── Bekleyen Proje Özel İzni ─────────────────────────────
            Kilit kartıyla birlikte görünür (bekleyen izin projeyi kilitli tutar) ve
            "Sistemi Onayla" düğmesini kapatır. Denetmen kararı burada da verebilir.
            ⚠️ Onaylı izin ihlalleri listeden SİLMEZ, PERMITTED'a çevirir — kural hâlâ
               çiğneniyor, sadece imzalanmış oluyor. Yeşil "tamam" basmıyoruz. */}
        {hasProject && pb?.ozelIzin && (pb.ozelIzinBekliyor || pb.ozelIzinli) && (
          <Card className={`mb-3 border ${pb.ozelIzinBekliyor ? "border-warning" : "border-info"}`}>
            <CardBody>
              <div className="d-flex align-items-center gap-2 mb-2 flex-wrap">
                <ShieldCheck size={16} className={pb.ozelIzinBekliyor ? "text-warning" : "text-info"} />
                <span className="fw-semibold">
                  {tx("standOverviewDetail.projeOzelIzni", { id: pb.ozelIzin.id })}{" "}{pb.ozelIzin.durumName ?? (pb.ozelIzinBekliyor ? tx("standOverviewDetail.onayBekliyor") : tx("standOverviewDetail.onaylandi"))}
                </span>
                {pb.ozelIzinBekliyor && <Badge color="warning">{tx("standOverviewDetail.beyanKabulEdilemez")}</Badge>}
              </div>
              <div className="text-muted small mb-2">
                <span className="fw-semibold">{pb.ozelIzin.talepEdenAdi ?? `#${pb.ozelIzin.talepEden}`}</span>
                {tx("standOverviewDetail.talepEtti")}
                {pb.ozelIzin.talepNotu
                  ? <>{" "}{tx("standOverviewDetail.gerekce")}{" "}{pb.ozelIzin.talepNotu}</>
                  : <>{" "}{tx("standOverviewDetail.gerekceYazilmamis")}</>}
              </div>
              {pb.ozelIzinBekliyor ? (
                <>
                  {/* Bu cümle olmadan "neden Sistemi Onayla kapalı?" sorusu gelir. */}
                  <Alert color="warning" className="small py-2">
                    {tx("standOverviewDetail.talepKararaBaglanmadanBeyanKabul")}
                  </Alert>
                  {permitDecision ? (
                    <>
                      <Input
                        type="textarea" rows={2} bsSize="sm" className="mb-2"
                        maxLength={OZEL_IZIN_NOT_MAX}
                        placeholder={permitDecision.onay
                          ? tx("standOverviewDetail.gerekceOpsiyonel")
                          : tx("standOverviewDetail.retGerekcesiZorunluKatilimcininOkuyacagi")}
                        value={permitNote} onChange={(e) => setPermitNote(e.target.value)}
                      />
                      <div className="d-flex gap-2">
                        <Button
                          color={permitDecision.onay ? "success" : "danger"} size="sm"
                          disabled={permitBusy || (!permitDecision.onay && !permitNote.trim())}
                          onClick={handlePermitDecision}
                        >
                          {permitBusy ? <Spinner size="sm" /> : permitDecision.onay ? tx("standOverviewDetail.onayla") : tx("standOverviewDetail.reddet")}
                        </Button>
                        <Button color="secondary" outline size="sm" disabled={permitBusy}
                          onClick={() => { setPermitDecision(null); setPermitNote(""); }}>
                          {tx("standOverviewDetail.vazgec")}
                        </Button>
                      </div>
                    </>
                  ) : (
                    <div className="d-flex gap-2">
                      <Button color="success" outline size="sm" onClick={() => setPermitDecision({ onay: true })}>
                        <ShieldCheck size={13} className="me-1" />{tx("standOverviewDetail.onayla")}
                      </Button>
                      <Button color="danger" outline size="sm" onClick={() => setPermitDecision({ onay: false })}>
                        {tx("standOverviewDetail.reddet")}
                      </Button>
                    </div>
                  )}
                </>
              ) : (
                <div className="text-muted small">
                  {tx("standOverviewDetail.onaylayan")}{" "}<span className="fw-semibold">{pb.ozelIzin.kararVerenAdi ?? `#${pb.ozelIzin.kararVeren}`}</span>
                  {pb.ozelIzin.kararNotu ? <> — {pb.ozelIzin.kararNotu}</> : null}
                  {tx("standOverviewDetail.yeniBirBeyanVerilirseBu")}
                </div>
              )}
            </CardBody>
          </Card>
        )}

        {hasProject && !pb?.locked && pb?.awaitingSystemAssignment && (
          <Card className="mb-3 border border-info">
            <CardBody>
              <div className="d-flex align-items-center gap-2 mb-2">
                <ClipboardCheck size={16} className="text-info" />
                <span className="fw-semibold">{tx("standOverviewDetail.sistemAtamasiBekliyor")}</span>
              </div>
              {/* Onay = "beyan ettiğini kabul ediyorum": backend beyan yüksekliğini kabul edilen
                  yükseklik yapar, cam/boyayı stand_detail'e yansıtır, tipi declaredStandTypeId'den
                  alır ve zorunlu belgeleri yeniden çözer. FE'nin göndermesi gereken TEK şey bant. */}
              <div className="text-muted small mb-2">
                {stripParallelTreeMarker(pb.declaredStandTypeName) ?? "—"} · {pb.declaredHeightNumber ?? "—"} m
              </div>
              {/* Kaydedilmiş uyarılar (WARNING) — beyanı engellemediler ama karar veren
                  kişinin görmesi gereken şeyler (ör. serbest kW hakkının aşılması: para
                  demek, kural ihlali değil). */}
              <KuralIhlalListesi violations={pb.violations} className="mb-2" />
              <DeclaredSpecStrip pb={pb} />

              {/* Duvar beyanı — /declaration/walls ile AYRI yazılıyor, beyanın gövdesinde
                  değil. Kabul kararını verirken görülmesi gereken bir şey.
                  ⚠️ `wallsAccepted` HİÇBİR ZAMAN true olmuyor (hiçbir uç duvar listesini
                     kabul etmiyor) — ona bakarak bir durum kurmayın. */}
              {pb.wallsDeclared && (
                <div className="text-muted small mb-2">
                  <span className="fw-semibold">{pb.wallCount ?? pb.walls?.length ?? 0}{" "}{tx("standOverviewDetail.duvar")}</span>{" "}{tx("standOverviewDetail.beyanEdildi")}
                  {(pb.walls ?? []).map((w) => `${w.width}×${w.height} m`).join(" · ")}
                </div>
              )}

              {/* Doldurulmamış ZORUNLU beyan formları — backend bunları düz metin bir
                  400 ile söylüyor. Düğmeyi önden kapatıp sebebini burada yazıyoruz. */}
              {blockingDeclarationForms(projectForms).length > 0 && (
                <Alert color="warning" className="small py-2">
                  <span className="fw-semibold">{tx("standOverviewDetail.buFuarinZorunluBeyanFormlari")}</span>
                  <ul className="mb-0 mt-1">
                    {blockingDeclarationForms(projectForms).map((f) => (
                      <li key={f.id}>
                        {f.formAdi ?? tx("standOverviewDetail.tanimiBulunamadi", { v: BEYAN_FORM_TIPI[f.formTipi]?.label ?? tx("standOverviewDetail.form"), id: f.id })}
                      </li>
                    ))}
                  </ul>
                </Alert>
              )}

              {/* Yükseklik bandı — beyan yüksekliğinden otomatik (pickHeightBand). Bant yoksa
                  (kök/ölü uç tip) veya yükseklik hiçbir banda düşmüyorsa elle seçim. */}
              <Row className="g-2 align-items-center">
                <Col md={8}>
                  {bandList === null ? (
                    <Spinner size="sm" />
                  ) : bandList.length === 0 ? (
                    <span className="small text-danger fw-semibold">
                      <AlertTriangle size={13} className="me-1" />{tx("standOverviewDetail.buStandTipiIcinYukseklik")}
                    </span>
                  ) : bandPick?.band && !bandManual ? (
                    <div className="d-flex align-items-center flex-wrap gap-2 small">
                      <span className="text-muted">{tx("standOverviewDetail.yukseklikBandi")}</span>
                      <Badge color="info" className="fs-12">{bandPick.band.stand_height_name}</Badge>
                      <span className="text-muted">{fmtBandRange(bandPick.band)}{" "}{tx("standOverviewDetail.otomatik")}</span>
                      {bandPick.matches.length > 1 && (
                        <span className="text-warning" title={bandPick.matches.map((b) => `${b.stand_height_name} (${fmtBandRange(b)})`).join(" · ")}>
                          {tx("standOverviewDetail.bantUyuyor", { length: bandPick.matches.length })}
                        </span>
                      )}
                      <Button
                        color="link" size="sm" className="p-0"
                        onClick={() => { setAssignHeightId(String(bandPick.band.stand_height_id)); setBandManual(true); }}
                      >
                        {tx("standOverviewDetail.degistir")}
                      </Button>
                    </div>
                  ) : (
                    <Input
                      type="select" bsSize="sm"
                      value={manualBandValid ? assignHeightId : ""}
                      onChange={(e) => { setAssignHeightId(e.target.value); setBandManual(true); }}
                    >
                      <option value="">
                        {/* WAS (until #671): bandPick?.reason === "NO_MATCH" ? ..., and every band of the type below (bandList.map) */}
                        {bandChoices.length === 0
                          ? tx("standOverviewDetail.mHicbirBandaUymuyorBant", { declaredHeightNumber: pb.declaredHeightNumber })
                          : tx("standOverviewDetail.yukseklikBandiSecin")}
                      </option>
                      {bandChoices.map((h) => (
                        <option key={h.stand_height_id} value={h.stand_height_id}>
                          {h.stand_height_name} · {fmtBandRange(h)}
                          {String(h.stand_height_id) === String(bandPick?.band?.stand_height_id) ? tx("standOverviewDetail.onerilen") : ""}
                        </option>
                      ))}
                    </Input>
                  )}
                </Col>
                <Col md={4}>
                  <Button
                    color="info" size="sm" className="w-100"
                    disabled={assigningSystem || !selectedHeightId || assignBlocked} onClick={handleAssignSystem}
                  >
                    {assigningSystem ? <Spinner size="sm" /> : tx("standOverviewDetail.sistemiOnayla")}
                  </Button>
                </Col>
              </Row>

              {/* Bu bantla istenecek belgeler + kabulde düşecek onaylar */}
              {bandPreview && (
                <div className="small mt-2">
                  <span className="text-muted me-1">
                    {tx("standOverviewDetail.zorunluBelgeler", { v: REQUIRED_FILES_LEVEL_LABELS[bandPreview.level] ?? bandPreview.level })}
                  </span>
                  {bandPreview.files?.length ? bandPreview.files.map((f) => (
                    <Badge key={f.stand_file_id} color="light" className="text-dark border me-1">
                      {f.stand_file_shortname ?? f.stand_file_name}
                    </Badge>
                  )) : <span className="text-muted">{tx("standOverviewDetail.yok2")}</span>}
                  {droppedApprovals.length > 0 && (
                    <div className="text-warning mt-1">
                      <AlertTriangle size={12} className="me-1" />
                      {tx("standOverviewDetail.onayiDusecek")}{" "}{droppedApprovals.map((fa) => fileShortName(fa.standFileId)).join(", ")}
                    </div>
                  )}
                </div>
              )}
            </CardBody>
          </Card>
        )}
        {/* ─── Beyan kabul edilmiş: kabul edilen yükseklik + hangi sınırlara göre ───
            ⚠️ Kapı `pb.accepted` DEĞİL. Canlıda (stand 57557, 2026-08-25) `accepted: true`
            ile `systemAssigned: false` AYNI ANDA gelebiliyor: `accepted`, projenin bir
            yüksekliğinin olup olmadığını söylüyor (eski `promisedMissing`'in tersi), adım
            3'ün çalışıp çalışmadığını DEĞİL. Ona bakınca "Sistem Ataması Bekliyor" ile
            "Beyan Kabul Edildi" kartları aynı anda çıkıyordu. Tek doğru kapı: atama bitti mi. */}
        {hasProject && !pb?.locked && isDeclarationAccepted(pb) && (
          <Card className="mb-3 border border-success">
            <CardBody>
              <div className="d-flex align-items-center gap-2 mb-2">
                <ClipboardCheck size={16} className="text-success" />
                <span className="fw-semibold">{tx("standOverviewDetail.beyanKabulEdildi")}</span>
                {/* `promisedHeightNumber` hâlâ tel üzerinde ama artık YANLIŞ İSİMLİ:
                    "söz verilen" değil, "kabul ettiğimiz" yükseklik. getAcceptedHeight
                    yeni adı tercih edip eskisine düşüyor. */}
                {getAcceptedHeight(pb) != null && (
                  <Badge color="success">{tx("standOverviewDetail.kabulEdilenYukseklikM", { getAcceptedHeight: getAcceptedHeight(pb) })}</Badge>
                )}
                {pb?.standHeightName && <Badge color="light" className="text-dark">{tx("standOverviewDetail.bant")}{" "}{pb.standHeightName}</Badge>}
              </div>
              <DeclaredSpecStrip pb={pb} />
              <KuralIhlalListesi violations={pb?.violations} title={tx("standOverviewDetail.buBeyanArtikKurallaraUymuyor")} />
              <div className="d-flex flex-wrap gap-4 text-muted small">
                {/* heightLimit null = "hiçbir yerde kayıt yok, yargılayamıyorum" —
                    "sınırsız" DEĞİL, o yüzden öyle yazmıyoruz. */}
                <span>
                  {tx("standOverviewDetail.gecerliYukseklikSiniri")}
                  <span className="fw-semibold text-body">
                    {describeHeightLimit({
                      heightLimit: pb?.effectiveHMax ?? null,
                      heightLimitSource: pb?.effectiveHMaxSource ?? null,
                    }) ?? tx("standOverviewDetail.kayitliSinirYok")}
                  </span>
                </span>
                {pb?.freeKw != null && (
                  <span>{tx("standOverviewDetail.serbestKWHakki")}{" "}<span className="fw-semibold text-body">{pb.freeKw}{" "}{tx("standOverviewDetail.kW")}</span></span>
                )}
                {requiredLevel?.level && (
                  <span>
                    {tx("standOverviewDetail.zorunluBelgeler2")}
                    <span className="fw-semibold text-body">
                      {REQUIRED_FILES_LEVEL_LABELS[requiredLevel.level] ?? requiredLevel.level}
                    </span>
                    {requiredLevel.belgeKuralId != null && (
                      <>
                        {" · "}
                        <Button
                          color="link" size="sm" className="p-0 align-baseline"
                          onClick={() => navigate("/Management/Fairs/Rules?tab=belge")}
                        >
                          {tx("standOverviewDetail.kural", { belgeKuralId: requiredLevel.belgeKuralId })}
                        </Button>
                      </>
                    )}
                  </span>
                )}
              </div>
            </CardBody>
          </Card>
        )}

        {hasProject && !pb?.locked && !pb?.awaitingSystemAssignment && pb && !pb.declared && (
          <Alert color="secondary" className="d-flex align-items-center gap-2 mb-3">
            <Clock size={14} />{" "}{tx("standOverviewDetail.dekoratorunProjeBeyaniBekleniyor")}
          </Alert>
        )}

        {hasProject && activeTab === "info" && (
          <>
        {/* WAS (until #210): the gray pill row. What only it showed (stand category, project type / structure, kW, Yerli-Yabancı) is a tile of Proje Bilgileri now.
            {/* ─── Bilgi pilleri ───
                Stand Listesi satırındaki ile BİREBİR aynı bileşen (StandBadgeRowFull):
                kategori · stand tipi · kat · proje tipi/yapısı · alan · yükseklik · kW.
                Yerli/Yabancı ayrı duruyor çünkü grid'e girmiyor (liste de öyle yapıyor).
                Hiçbiri dolu değilse (roster satırı bulunamadıysa) kart hiç basılmaz —
                boş bir "—" ızgarası göstermek bilgi vermeyen gürültü olurdu. * /}
            {(stand.standCategory || stand.standTypeName || stand.floorInfo
              || stand.projectStructure || stand.standArea != null
              || stand.projectHeightNumber != null || stand.kw != null) && (
              <Card className="mb-3">
                <CardBody className="d-flex flex-wrap align-items-center gap-3">
                  {stand.firmaNation != null && (
                    <Badge color="success" className="d-inline-flex align-items-center gap-1 px-2 py-1">
                      {stand.firmaNation === 1 ? tx("standOverviewDetail.yerli") : tx("standOverviewDetail.yabanci")}
                    </Badge>
                  )}
                  <StandBadgeRowFull s={stand} columns={4} showKw />
                </CardBody>
              </Card>
            )}

        */}
            {/* ─── Proje Bilgileri ─── */}
            {/* WAS: <RequiredFileRibbon label={tx("standOverviewDetail.projeBilgileri")}> */}
            <RequiredFileRibbon label={tx("standOverviewDetail.projeBilgileri")} action={editButton}>
              <div className="w-100">
                <Row className="text-center">
                  {[
                    ...typeTiles,
                    {
                      icon: Ruler,
                      // standHeightName Sistem Ataması'ndan sonra dolan, projectHeightNumber'dan
                      // (söz verilen/beyan edilen tek sayı) daha spesifik bir alan — onaylanmış
                      // yükseklik BANDI (ör. "4,50 m'den büyük"), bkz. FE-ProjectController-
                      // catalog-guide.md "GET /stand-heights-classic".
                      label: tx("standOverviewDetail.stantYuksekligi", { v: projectHeightNumber ? `${projectHeightNumber} m` : "—", v2: bridgedProject?.standHeightName ? ` (${bridgedProject.standHeightName})` : "" }),
                    },
                    { icon: Maximize2, label: tx("standOverviewDetail.stantAlani", { v: stand.standArea ? `${stand.standArea} m²` : "—" }) },
                    // typeTiles zaten kat kategorisini (seviye 2) içeriyorsa burada tekrar
                    // etmiyoruz — sadece ağaç çözülemediğinde (mock/fallback) devreye girer.
                    ...(effectiveStandTypePath.length > 0 ? [] : [{ icon: Building2, label: tx("standOverviewDetail.katBilgisi2", { v: katBilgisiDisplay ?? "—" }) }]),
                    ...ekBilgiTiles,
                  ].map(({ icon: Icon, label }) => (
                    <Col md={3} key={label}>
                      <div
                        className="d-inline-flex align-items-center justify-content-center bg-info-subtle text-info rounded-circle mb-2"
                        style={{ width: 44, height: 44 }}
                      >
                        <Icon size={20} />
                      </div>
                      <div className="small">{label}</div>
                    </Col>
                  ))}
                </Row>
              </div>
            </RequiredFileRibbon>

            {/* ─── Zorunlu Belge Görselleri ─── */}
            <Row className="g-3 mt-1">
              <Col md={4}>
                <StatikOrElektrikCard
                  label={tx("standOverviewDetail.statikHesap")} icon={Box} approvalStatus={fileApprovalsMap[7]}
                  tracking={takip(7, versionEntries(filesOfTitle(uploadedFiles, 7)))}
                />
              </Col>
              <Col md={4}>
                <ProjeGorselleriCard
                  uploadedFiles={uploadedFiles}
                  standFileId={projeGorselleriStandFileId}
                  angles={projeGorselleriAngles}
                  tracking={takip(projeGorselleriStandFileId, angleEntries(filesOfTitle(uploadedFiles, projeGorselleriStandFileId), projeGorselleriAngles))}
                />
              </Col>
              <Col md={4}>
                <StatikOrElektrikCard
                  label={tx("standOverviewDetail.teknikTalepPlani")} icon={Zap} approvalStatus={fileApprovalsMap[3]}
                  tracking={takip(3, versionEntries(filesOfTitle(uploadedFiles, 3)))}
                />
              </Col>
            </Row>

            {/* #209: Stand Planı - standın kendi planı + salondaki yeri */}
            {planBolumu}

            {/* standTalep/detay updatedAt vermiyor (canlıda her zaman null) — proje
                kaydının kendi updatedAt'ine düşüyoruz; "—" basmaktansa gerçek bir
                tarih göstermek doğru, ve denetçinin sorduğu soru zaten "bu proje
                en son ne zaman değişti". */}
            <div className="text-muted small mt-3">
              {tx("standOverviewDetail.sonGuncelleme", { fmtDate: fmtDate(stand.updatedAt ?? bridgedProject?.updatedAt) })}
            </div>
          </>
        )}

        {!hasProject && activeTab === "info" && planBolumu}

        {hasProject && activeTab === "files" && (
          <div className="d-flex flex-column gap-3">
            {DOC_GROUPS.map((g) => (
              <DocGroupRow
                key={g.standFileId}
                label={g.label}
                standFileId={g.standFileId}
                overallStatus={fileApprovalsMap[g.standFileId] ?? 0}
                files={uploadedFiles.filter((f) => f.standFileId === g.standFileId)}
                // Canlı modda "ana belge seç" artık sadece "Proje Durumu" sekmesindeki
                // gerçek Taahütnameler (standFileId 5) dosyalarında anlamlı — buradaki
                // 2/3/7 grupları farklı başlıklar, çapraz seçim canlı backend'de
                // yanlış dosyayı taahhütname kaynağı yapardı (bkz. dosya başı
                // deriveCommitmentStage notu). Mock modda eski davranış korunuyor.
                commitments={isLiveStandId ? [] : commitments}
                actionLoading={actionLoading}
                onSetApproval={handleFileApproval}
                onReviewFile={handleFileReview}
                onPreview={setPreviewFile}
                tracking={takip(
                  g.standFileId,
                  g.standFileId === projeGorselleriStandFileId
                    ? angleEntries(filesOfTitle(uploadedFiles, g.standFileId), projeGorselleriAngles)
                    : versionEntries(filesOfTitle(uploadedFiles, g.standFileId)),
                  false,
                )}
                onChooseCommitment={handleChooseCommitment}
                openRevision={openVisualByFile[g.standFileId]}
                onShowRevision={(r) => goToRevision(r._id)}
                angleLabels={g.standFileId === projeGorselleriStandFileId ? projeGorselleriAngleLabels : (g.standFileId === 5 ? PROJE_GORSELLERI_ANGLE_LABELS : null)}
              />
            ))}
          </div>
        )}

        {hasProject && activeTab === "commitments" && (
          <RequiredFileRibbon label={tx("standOverviewDetail.projeDurumu")}>
            <div className="w-100">
              {/* 2026-09-04: buradaki Borç rozeti kaldırıldı — banner'a taşındı (izin
                  rozetlerinin yanına, Stand Listesi'nin "i" göstergesiyle aynı beşli).
                  Aynı bilgiyi iki yerde göstermenin bir faydası yoktu. */}
              {/* İnşa İzni / İş İzni / zorunlu belge sayacı — hepsi aynı 40×40 durum
                  karesi + yanında etiket, /Firma/Projeler'in StatusTile sözlüğüyle.
                  Renk de oradan: İnşa İzni'ninki backend'in verdiği stand_status.badge,
                  ve metin "Alındı/Alınmadı" değil gerçek durum adı — "İnşa İznine Gerek
                  yok" ile "İzin Verilmedi" ikisi de "alınmadı" ama zıt anlamlı
                  (bkz. missing-pills-guide.md §5). */}
              <div className="d-flex justify-content-center flex-wrap gap-4 mb-4">
                <div className="d-flex align-items-center gap-2">
                  <StatusTile icon={ShieldCheck} color={insaIzniBadge.color} label={tx("standOverviewDetail.insaIzni2", { label: insaIzniBadge.label })} />
                  <div>
                    <div className="small fw-semibold">{tx("standOverviewDetail.insaIzni3")}</div>
                    <Badge color={insaIzniBadge.color} className="fw-normal">{insaIzniBadge.label}</Badge>
                  </div>
                </div>
                <div className="d-flex align-items-center gap-2">
                  <StatusTile icon={HardHat} color={isIzniBadge.color} label={tx("standOverviewDetail.isIzni2", { label: isIzniBadge.label })} />
                  <div>
                    <div className="small fw-semibold">{tx("standOverviewDetail.isIzni3")}</div>
                    <Badge color={isIzniBadge.color} className="fw-normal">{isIzniBadge.label}</Badge>
                  </div>
                </div>
                {/* Zorunlu belge sayacı — eskiden "İnşaat İzni"nin ta kendisi sanılıyordu.
                    Ayrı bir cümle olarak duruyor: izni bu belirlemiyor, ama denetçinin
                    bakması gereken bir ilerleme göstergesi. */}
                {requiredCount > 0 && (
                  <div className="d-flex align-items-center gap-2">
                    <StatusTile
                      icon={FileCheck2}
                      color={tumBelgelerOnayli ? "success" : "warning"}
                      label={tx("standOverviewDetail.onaylananZorunluBelge", { approvedCount, requiredCount })}
                    />
                    <div>
                      <div className="small fw-semibold">{tx("standOverviewDetail.zorunluBelge")}</div>
                      <Badge color={tumBelgelerOnayli ? "success" : "warning"} className="fw-normal">
                        {approvedCount} / {requiredCount}
                      </Badge>
                    </div>
                  </div>
                )}
              </div>
              {isLiveStandId ? (
                <TaahhutnameDurumuPaneli
                  data={taahhut?.projectId === bridgedProject?.id ? taahhut : null}
                  projectId={bridgedProject?.id}
                  hata={taahhutHata}
                  onYenile={() => { setTaahhutHata(null); setTaahhutYenile((n) => n + 1); }}
                  uploadedFiles={uploadedFiles}
                  actionLoading={actionLoading}
                  onChoose={handleChooseCommitment}
                  onReviewFile={handleFileReview}
                  onPreview={setPreviewFile}
                  onElektrikciKaydet={handleElektrikciKaydet}
                  onElektrikciKaldir={handleElektrikciKaldir}
                  onElektrikciFoto={handleElektrikciFoto}
                />
              ) : commitments.length === 0 ? (
                <Alert color="secondary" className="mb-0">{tx("standOverviewDetail.taahhutnameBulunamadi")}</Alert>
              ) : rosterCommitments ? (
                <>
                  <Row>
                    {rosterCommitments.map((c) => (
                      <SourceCommitmentTile
                        key={c.key}
                        commitment={c}
                        uploadedFiles={uploadedFiles}
                        actionLoading={actionLoading}
                        onChoose={isLiveStandId ? handleChooseCommitment : undefined}
                        onPreview={setPreviewFile}
                      />
                    ))}
                  </Row>
                  {rosterCommitments.every((c) => c.state === "SIGNED") ? (
                    <Alert color="success" className="d-flex align-items-center gap-2 mb-0 mt-2">
                      <Check size={16} />{" "}{tx("standOverviewDetail.n3TaahhutnameDeImzalandi")}
                    </Alert>
                  ) : (
                    /* Zincirin nerede takıldığını tek cümlede söyler — denetçi hangi
                       kutuya bakacağını aramasın. PDF üretimi henüz olmadığı için
                       "kaynak seçildi" bugün ulaşılabilen son durum. */
                    <div className="text-muted small mt-2">
                      {tx("standOverviewDetail.bekleyen")}{" "}{rosterCommitments
                        .filter((c) => c.state !== "SIGNED")
                        .map((c) => `${c.label} (${COMMITMENT_STATE[c.state]?.label ?? c.state})`)
                        .join(" · ")}
                    </div>
                  )}
                </>
              ) : (
                <>
                  <Row>
                    {commitments.map((c) => {
                      // Mock kayıtlar eski {status,fileId} şeklini taşır — canlı köprüde
                      // zaten stage/files dolu gelir (synthesizeCommitments). Mock modda
                      // "seç" aksiyonu (onChoose) bilerek verilmiyor: mock commitments statik
                      // yazılmış, bir choose çağrısı onu güncellemez (bkz. FirmaStandDetailPage.jsx'teki
                      // aynı gerekçe).
                      const stage = c.stage ?? (c.status === 1 ? "done" : (c.fileId != null ? "draft" : "empty"));
                      const files = c.files ?? (c.fileId
                        ? [uploadedFiles.find((f) => f.id === c.fileId) ?? { id: c.fileId, originalFileName: "belge.pdf", approvalStatus: c.status ?? 0, uploadedAt: stand.updatedAt }]
                        : []);
                      return (
                        <CommitmentTile
                          key={c.key}
                          label={c.label}
                          stage={stage}
                          files={files}
                          actionLoading={actionLoading}
                          onChoose={isLiveStandId ? (fileId) => handleChooseCommitment(c.key, fileId) : undefined}
                          onPreview={setPreviewFile}
                        />
                      );
                    })}
                  </Row>
                  {isLiveStandId && commitments.every((c) => c.stage === "done") && (
                    <Alert color="success" className="d-flex align-items-center gap-2 mb-0 mt-2">
                      <Check size={16} />{" "}{tx("standOverviewDetail.n3TaahhutnameDeTamamlandiInsaat")}
                    </Alert>
                  )}
                </>
              )}
            </div>
          </RequiredFileRibbon>
        )}

        {/* WAS (until #209): the Kroki tab. Its job - the stand on its hall plan - is the "Stand Planı" section of the info tab.
        {/* Kroki — gömülü fdsvector stand planı. Bilinçli olarak hasProject
            kapısının DIŞINDA: standın salondaki yerleşimi proje kaydından
            bağımsızdır (proje olmayan standın da salonu vardır). * /}
        {activeTab === "kroki" && (
          <Card>
            <CardHeader className="d-flex justify-content-between align-items-center flex-wrap gap-2">
              <h6 className="mb-0">{tx("standOverviewDetail.salonStandYerlesimi")}</h6>
              <span className="text-muted" style={{ fontSize: 12 }}>
                {stand.standName ? tx("standOverviewDetail.stand2", { standName: stand.standName }) : ""}
                {stand.salonName ? tx("standOverviewDetail.salon", { salonName: stand.salonName }) : ""}
              </span>
            </CardHeader>
            <CardBody>
              <Alert color="info" className="d-flex align-items-start gap-2">
                <AlertTriangle size={18} className="flex-shrink-0 mt-1" />
                <div>
                  {tx("standOverviewDetail.buKroki")}{" "}<strong>{tx("standOverviewDetail.salonunTamamini")}</strong>{" "}{tx("standOverviewDetail.gosterirGommeUcundaTekStandi")}<code>{tx("standOverviewDetail.embedStandPlan")}</code>{" "}{tx("standOverviewDetail.yalnizca")}
                  <code className="mx-1">{tx("standOverviewDetail.fairId")}</code>+<code>{tx("standOverviewDetail.hallId")}</code>{" "}{tx("standOverviewDetail.alirStandlarinKrokiyeBaglanmasiSekil")}
                  <code className="mx-1">{tx("standOverviewDetail.standId")}</code>/<code>{tx("standOverviewDetail.standNo")}</code>{" "}{tx("standOverviewDetail.tutulur")}
                </div>
              </Alert>

              {!krokiProbe ? (
                <div className="text-center py-5">
                  <Spinner color="primary" />
                  <div className="text-muted small mt-2">{tx("standOverviewDetail.krokiAraniyor")}</div>
                </div>
              ) : (
                <>
                  {!krokiKendiPlani && (
                    <Alert color="warning" className="d-flex align-items-start gap-2">
                      <AlertTriangle size={18} className="flex-shrink-0 mt-1" />
                      <div>
                        {krokiProbe.reason === "missing-id" ? (
                          <>
                            {tx("standOverviewDetail.buStandin")}{" "}{stand.fuarId ? tx("standOverviewDetail.salon2") : tx("standOverviewDetail.fuar")}{" "}{tx("standOverviewDetail.idSiOkunamadi")}<code>{tx("standOverviewDetail.fuarId")}{String(stand.fuarId ?? "—")}</code> ·{" "}
                            <code>{tx("standOverviewDetail.salonId")}{String(stand.salonId ?? "—")}</code>).
                          </>
                        ) : krokiProbe.reason === "not-mapped" ? (
                          <>
                            {tx("standOverviewDetail.buStandinSalonunun")}<code>{tx("standOverviewDetail.fuarId")}{String(stand.fuarId)}</code> ·{" "}
                            <code>{tx("standOverviewDetail.salonId")}{String(stand.salonId)}</code>{tx("standOverviewDetail.krokisiHenuzCizilmemisKrokiUygulamasi", { message: krokiProbe.message })}
                          </>
                        ) : (
                          <>{tx("standOverviewDetail.krokiSorgusuBasarisiz")}{" "}{krokiProbe.message}</>
                        )}{" "}
                        {tx("standOverviewDetail.asagidakiKrokiBuYuzden")}{" "}<strong>{tx("standOverviewDetail.buStandaAitDegil")}</strong>{tx("standOverviewDetail.ornekOlarakFdsvectorDekiTek")}
                        <strong>{ORNEK_STAND_PLAN.ad}</strong>{" "}
                        (<code>{tx("standOverviewDetail.fairId2")}{ORNEK_STAND_PLAN.fairId}</code> ·{" "}
                        <code>{tx("standOverviewDetail.hallId2")}{ORNEK_STAND_PLAN.hallId}</code>{tx("standOverviewDetail.baskaBirIdCiftiDenemek")}{" "}<strong>{tx("standOverviewDetail.kaynak2")}</strong>{" "}{tx("standOverviewDetail.dugmesiniKullanin")}
                      </div>
                    </Alert>
                  )}

                  {/* Backlog #236: salt okunur. KrokiVectorEmbed'in allowEdit varsayılanı true — "Düzenle"
                      buradan Alan Planı'nı, Salon Planı kapısını (#235) atlayarak açıyordu. Alan
                      Planı düzenlemesi yalnızca SalonAlanPlaniPage'de. * /}
                  <KrokiVectorEmbed
                    fairId={krokiFairId}
                    hallId={krokiHallId}
                    allowEdit={false}
                    height={560}
                  />
                </>
              )}
            </CardBody>
          </Card>
        )}

        */}
        {hasProject && activeTab === "revisions" && (
          <Card>
            <CardHeader className="d-flex justify-content-between align-items-center">
              <h6 className="mb-0">{tx("standOverviewDetail.revizyonKonusmalari")}</h6>
              <Button
                color="primary"
                size="sm"
                onClick={() => setRevisionModal(true)}
                disabled={actionLoading || !bridgedProject}
                title={!bridgedProject ? tx("standOverviewDetail.buStandaBagliBirProje") : undefined}
              >
                <Plus size={13} className="me-1" />{" "}{tx("standOverviewDetail.yeniRevizyon")}
              </Button>
            </CardHeader>
            <CardBody>
              {!bridgedProject ? (
                <Alert color="secondary" className="mb-0">
                  {tx("standOverviewDetail.buStandaBagliBirProje2")}
                </Alert>
              ) : revisions.length === 0 ? (
                <Alert color="secondary" className="mb-0">{tx("standOverviewDetail.revizyonKonusmasiYok")}</Alert>
              ) : (
                <div className="d-flex flex-column gap-2">
                  {revisions.map((r) => {
                    const targetFile = r.standFileId != null
                      ? (bridgedProject.requiredFiles || []).find(f => f.stand_file_id === r.standFileId)
                      : null;
                    const fieldLabel = r.fieldKey
                      ? (revisableFields.find(f => f.key === r.fieldKey)?.label ?? r.fieldKey)
                      : null;
                    // "Sıra bizde" = ANSWERED: tamponda karar bekleyen bir değer (ya
                    // da yüklenmiş bir dosya) var. inRevision'dan ayrı bir bilgi —
                    // biri "bir sorun bulundu", bu "hamle bizim".
                    const awaitingUs = r.status === "answered";
                    return (
                      <div key={r._id} className={`border rounded p-2 d-flex justify-content-between align-items-start ${awaitingUs ? "border-warning" : ""}`}>
                        <div>
                          <div className="d-flex align-items-center gap-2 mb-1 flex-wrap">
                            <Badge color={REVISION_TARGET_KIND[r.targetKind]?.color ?? "secondary"}>
                              {REVISION_TARGET_KIND[r.targetKind]?.label ?? r.targetKind}
                            </Badge>
                            <Badge color={REVISION_STATUS[r.status]?.color ?? "secondary"}>{REVISION_STATUS[r.status]?.label ?? r.status}</Badge>
                            <Badge color={REVISION_OPENED_BY[r.openedByRole]?.color ?? "secondary"} pill>
                              {REVISION_OPENED_BY[r.openedByRole]?.label ?? r.openedByRole}
                            </Badge>
                            {targetFile && <span className="small text-muted">{targetFile.stand_file_name}</span>}
                            {fieldLabel && <span className="small text-muted">{fieldLabel}</span>}
                          </div>
                          <div className="small text-muted">
                            {tx("standOverviewDetail.mesajSonGuncelleme", { length: r.messages.length, fmtDateTime: fmtDateTime(r.updatedAt) })}
                          </div>
                          {r.proposed && (
                            <div className="small mt-1">
                              <span className="text-muted">{tx("standOverviewDetail.masadakiOneri")}{" "}</span>
                              <span className="fw-semibold">
                                {typeof r.proposed.value === "boolean"
                                  ? (r.proposed.value ? tx("common:evet") : tx("common:hayir"))
                                  : String(r.proposed.value ?? "—")}
                              </span>
                              <span className="text-muted">{" "}{tx("standOverviewDetail.henuzProjeyeYazilmadi")}</span>
                            </div>
                          )}
                        </div>
                        <div className="d-flex gap-1">
                          <Button
                            color="info"
                            size="sm"
                            outline
                            onClick={() => goToRevision(r._id)}
                          >
                            <Eye size={12} className="me-1" />{" "}{tx("common:goruntule")}
                          </Button>
                          <Button
                            color="danger"
                            size="sm"
                            outline
                            onClick={() => setDeleteRevisionId(r._id)}
                            disabled={actionLoading}
                          >
                            <Trash2 size={12} />
                          </Button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </CardBody>
          </Card>
        )}

        {/* ─── MODAL: Yeni Revizyon ─── */}
        <Modal isOpen={revisionModal} toggle={closeRevisionModal}>
          <ModalHeader toggle={closeRevisionModal}>{tx("standOverviewDetail.yeniRevizyon")}</ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label>{tx("standOverviewDetail.neyleIlgili")}</Label>
              <div className="d-flex gap-2 flex-wrap">
                <Button
                  color={revisionTargetKind === "DOCUMENT" ? "primary" : "secondary"}
                  outline={revisionTargetKind !== "DOCUMENT"}
                  size="sm"
                  onClick={() => { setRevisionTargetKind("DOCUMENT"); setRevisionFieldKey(""); }}
                >
                  {tx("standOverviewDetail.belge")}
                </Button>
                <Button
                  color={revisionTargetKind === "SPEC_FIELD" ? "primary" : "secondary"}
                  outline={revisionTargetKind !== "SPEC_FIELD"}
                  size="sm"
                  disabled={revisableFields.length === 0}
                  title={revisableFields.length === 0 ? tx("standOverviewDetail.revizeEdilebilirAlanListesiAlinamadi") : undefined}
                  onClick={() => { setRevisionTargetKind("SPEC_FIELD"); setRevisionStandFileId(""); }}
                >
                  {tx("standOverviewDetail.beyanAlani")}
                </Button>
                <Button
                  color={revisionTargetKind === "FREEFORM" ? "primary" : "secondary"}
                  outline={revisionTargetKind !== "FREEFORM"}
                  size="sm"
                  onClick={() => { setRevisionTargetKind("FREEFORM"); setRevisionStandFileId(""); setRevisionFieldKey(""); }}
                >
                  {tx("standOverviewDetail.serbestNot")}
                </Button>
              </div>
              <div className="text-muted small mt-1">
                {revisionTargetKind === "DOCUMENT" && tx("standOverviewDetail.belirliBirZorunluBelgeninYeniden")}
                {revisionTargetKind === "SPEC_FIELD" && tx("standOverviewDetail.tekBirBeyanAlanininDuzeltilmesini")}
                {revisionTargetKind === "FREEFORM" && tx("standOverviewDetail.projeninGenelineDairNotMakine")}
              </div>
            </FormGroup>

            {revisionTargetKind === "DOCUMENT" && (
              <FormGroup>
                <Label>{tx("standOverviewDetail.belgeTipi")}</Label>
                <Input
                  type="select"
                  value={revisionStandFileId}
                  onChange={e => setRevisionStandFileId(e.target.value)}
                >
                  <option value="">{tx("standOverviewDetail.secin")}</option>
                  {(bridgedProject?.requiredFiles || []).map(rf => (
                    <option key={rf.stand_file_id} value={rf.stand_file_id}>
                      {rf.stand_file_name}
                    </option>
                  ))}
                </Input>
              </FormGroup>
            )}

            {revisionTargetKind === "SPEC_FIELD" && (
              <FormGroup>
                <Label>{tx("standOverviewDetail.beyanAlani")}</Label>
                <Input
                  type="select"
                  value={revisionFieldKey}
                  onChange={e => setRevisionFieldKey(e.target.value)}
                >
                  <option value="">{tx("standOverviewDetail.secin")}</option>
                  {revisableFields.map(f => (
                    <option key={f.key} value={f.key}>{f.label}</option>
                  ))}
                </Input>
                {(() => {
                  const meta = revisableFields.find(f => f.key === revisionFieldKey);
                  if (!meta) return null;
                  return (
                    <div className="text-muted small mt-1">
                      {meta.note}
                      {meta.requiresSystemReassign && (
                        <div className="text-warning">
                          {tx("standOverviewDetail.buAlanKabulEdilirseProje")}
                        </div>
                      )}
                    </div>
                  );
                })()}
              </FormGroup>
            )}

            <FormGroup>
              <Label>{tx("standOverviewDetail.mesaj")}</Label>
              <Input
                type="textarea"
                rows={4}
                placeholder={tx("standOverviewDetail.revizyonTalebiniziYazin")}
                value={revisionText}
                onChange={e => setRevisionText(e.target.value)}
              />
            </FormGroup>

            {/* Ekran görüntüsü hedef türünden bağımsız — backend her revizyon
                tipinde kabul ediyor, belge revizyonunda "şu köşeye bak" demek de
                en az serbest notta olduğu kadar işe yarıyor. */}
            <FormGroup>
              <Label>{tx("standOverviewDetail.ekranGoruntusuOpsiyonel")}</Label>
              <Input
                type="file"
                accept="image/*"
                innerRef={screenshotInputRef}
                onChange={e => setRevisionScreenshot(e.target.files[0] || null)}
              />
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={closeRevisionModal}>{tx("common:iptal")}</Button>
            <Button
              color="primary"
              onClick={handleCreateRevision}
              disabled={
                actionLoading || !revisionText.trim()
                || (revisionTargetKind === "DOCUMENT" && !revisionStandFileId)
                || (revisionTargetKind === "SPEC_FIELD" && !revisionFieldKey)
              }
            >
              {actionLoading ? <Spinner size="sm" /> : tx("standOverviewDetail.olustur")}
            </Button>
          </ModalFooter>
        </Modal>

        {/* ─── MODAL: Revizyon Sil Onay ─── */}
        <Modal isOpen={!!deleteRevisionId} toggle={() => setDeleteRevisionId(null)}>
          <ModalHeader toggle={() => setDeleteRevisionId(null)}>{tx("standOverviewDetail.revizyonuSil")}</ModalHeader>
          <ModalBody>
            <Alert color="warning">
              {tx("standOverviewDetail.buRevizyonKonusmasiniTumMesajlariyla")}
            </Alert>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={() => setDeleteRevisionId(null)}>{tx("common:iptal")}</Button>
            <Button color="danger" onClick={handleDeleteRevision} disabled={actionLoading}>
              {actionLoading ? <Spinner size="sm" /> : tx("common:sil")}
            </Button>
          </ModalFooter>
        </Modal>

        {/* #210: Proje Bilgilerini Düzenle */}
        <ProjeBilgiDuzenleModal
          isOpen={projeDuzenle}
          toggle={() => setProjeDuzenle(false)}
          project={bridgedProject}
          onSaved={async () => {
            setProjeDuzenle(false);
            // The PUT already succeeded: a failed reload must not look like a failed save.
            try {
              await refreshStand();
              showSuccess(tx("projeBilgiDuzenle.kaydedildi"));
            } catch (e) {
              setError(e.message);
            }
          }}
        />

        <DocumentPreviewModal
          isOpen={!!previewFile}
          toggle={() => setPreviewFile(null)}
          fileName={previewFile?.originalFileName}
          fileUrl={isLiveStandId ? getProjectFileUrl(previewFile?.storedFileName) : undefined}
        />
      </Container>
    </div>
  );
}
